<template>
	<div class="content_main">
		<div class="content_main_top">
			<a-input placeholder="请输入审批编号" allowClear class="a_input_self margin_self" v-model="queryParam.applyCode"
				@keyup.enter.native="$refs.table.refresh(true)" />
			<a-input placeholder="请输入审批标题" allowClear class="a_input_self margin_self" v-model="queryParam.title"
				@keyup.enter.native="$refs.table.refresh(true)" />
			<a-select placeholder="所属流程" show-search :filter-option="filterOption" allowClear
				class="a_input_self margin_self" v-model="queryParam.procDefKey"
				@keyup.enter.native="$refs.table.refresh(true)">
				<a-select-option :value="item.id" v-for="(item, index) in Approvallist" :key="index">
					{{ item.name }}
				</a-select-option>
			</a-select>
			<a-select placeholder="请选择状态" class="a_input_self margin_self" v-model="queryParam.status" default-value="0"
				@keyup.enter.native="$refs.table.refresh(true)">
				<a-select-option :value="''">全部</a-select-option>
				<a-select-option v-for="(val, key) in status_apply" :key="key" :value="key">{{ val.txt }}
				</a-select-option>
			</a-select>
			<a-select placeholder="请选择审批结果" class="a_input_self margin_self" v-model="queryParam.result"
				default-value="0" @keyup.enter.native="$refs.table.refresh(true)">
				<a-select-option :value="''">全部</a-select-option>
				<a-select-option v-for="(val, key) in resultMap" :key="key" :value="key">{{ val }}</a-select-option>
			</a-select>
			<a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
			<a-button style="margin-left: 8px" @click="() => (queryParam = {})">重置</a-button>
			<a-button v-if="$store.getters.userInfo.userId == 1" type="primary" icon="plus" @click="$refs.modal.add()">
				新建
			</a-button>
			<a-button v-if="addBusinessList" type="primary" @click="addApply">新增申请</a-button>
			<!-- <a-button type="danger" v-if="selectedRowKeys.length > 0 && deleteBusinessList" icon="delete" @click="delByIds(selectedRowKeys)">删除</a-button> -->
		</div>
		<div class="content_main_center" id="content_main_center_scroll2">
			 <!-- :rowSelection="rowSelection"  -->
			<s-table size="default" ref="table" rowKey="id" :columns="columns"
				:data="loadData" :scroll="{ x: 2000, y: scroll_y }" defaultSort="applyTime">
				<span slot="serial" slot-scope="text, record, index">
					{{ index + 1 }}
				</span>
				<span slot="status" slot-scope="text" class="tag_class"
					:style="{ background: status_apply[text].color }">
					{{ status_apply[text].txt }}
				</span>
				<span slot="result" slot-scope="text" class="tag_class"
					:style="{ background: result_apply[text].color }">
					{{ result_apply[text].txt }}
				</span>
				<span slot="action" slot-scope="text, record">
					<!-- <a v-if="infoBusinessList" @click="needClick(record)">投标</a>
					<a-divider type="vertical" /> -->
					<a v-if="infoBusinessList" @click="handelAuditone(record)">详情</a>
					<a-divider type="vertical" />
					<a @click="handFlow(record)">历史</a>
					<a-divider type="vertical" />
					<a v-if="cancelBusinessList" :disabled="record.status !== 1"
						@click="cancel([record.procInstId])">撤销</a>
					<a-divider type="vertical" />
					<a @click="againAudit(record)">重新提交</a>
					<a-divider type="vertical" />
					<a :disabled="record.status !== 1 || record.procDefKey === 'bid'" @click="addDocuments(record)">补充文件</a>
				</span>
			</s-table>
		</div>
		<proc-flow-modal ref="modalflow" @ok="handleOk" />
		<business-modal ref="modal" @ok="handleOk" />
		<leave-modal ref="leavemodal" @ok="handleOk" :audit="false" />
		<purchase-modal ref="purchasemodal" @ok="handleOk" :audit="false" />
		<scrap-modal ref="scrapmodal" @ok="handleOk" :audit="false" />
		<receive-modal ref="receiveModal" @ok="handleOk" :audit="false" />
		<operation-modal ref="operationmodal" @ok="handleOk" :audit="false" />
		<service-modal ref="servicemodal" @ok="handleOk" :audit="false" />
		<reimbursement-modal ref="reimbursementmodal" @ok="handleOk" :audit="false" />
		<!-- 详情 -->
		<payMentModal ref="paymentmodal" @ok="handleOk" :audit="false" />
		<!-- 详情 -->
		<contractModal ref="contractmodal" @ok="handleOk" :audit="false" />
		<sealModal ref="sealmodal" @ok="handleOk" :audit="false" />
		<currencyModal ref="currencymodal" @ok="handleOk" :audit="false" />
		<returnModal ref="returnmodal" @ok="handleOk" :audit="false" />
		<car-modal ref="carmodal" @ok="handleOk" :audit="false" />
		<returncar-modal ref="returncarmodal" @ok="handleOk" :audit="false" />
		<salaryModal ref="salarymodal" @ok="handleOk" :audit="false" />
		<adjustmentModal ref="adjustmentmodal" @ok="handleOk" :audit="false" />
		<charge-modal ref="chargemodal" @ok="handleOk" :audit="false" />
		<other-modal ref="othermodal" @ok="handleOk" :audit="false" />
		<feedback-modal ref="feedbackmodal" @ok="handleOk" :audit="false" />
		<inventory-modal ref="inventorymodal" @ok="handleOk" :audit="false" />
		<a-modal title="采购申请重新提交" :visible="visible" :closable="true" @cancel="handleCancel"
			:confirm-loading="confirmLoading" width="60%" :maskClosable="false">
			<template slot="footer">
				<a-button key="back" @click="handleCancel"> 取消 </a-button>
				<a-button key="submit" type="primary" :loading="loading" @click="handleOkAdd"> 提交 </a-button>
			</template>
			<a-form-model ref="cgruleForm" :rules="rules" :model="info" :label-col="labelCol" :wrapper-col="wrapperCol">
				<a-row>
					<a-form-model-item label="选择抄送人" :label-col="labelCol2" :wrapper-col="wrapperCol2">
						<ccChange :data="ccC" @targetKeys="getdata" v-if="isRouterAlive" />
					</a-form-model-item>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="费用归属部门" prop="ascriptionDept" :rules="{
							required: true,
							message: '请选择费用归属部门',
							trigger: 'change',
						}">
							<a-select allowClear placeholder="请选择" v-model="info.ascriptionDept" style="width: 364px;">
								<a-select-option :value="item.dept_id" v-for="(item, index) in deptlist" :key="index">
									{{ item.dept_name }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="采购类型" prop="itemType" :rules="{
							required: true,
							message: '请选择采购类型',
							trigger: 'change',
						}">
							<a-select allowClear placeholder="请选择" v-model="info.itemType" style="width: 364px">
								<a-select-option :value="index" v-for="(item, index) in operTypeMap" :key="index">
									{{ item.text }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="期望交付日期" prop="expectDate" :rules="{
							required: true,
							message: '请选择期望交付日期',
							trigger: 'change',
						}">
							<a-date-picker valueFormat="YYYY-MM-DD" style="width: 364px" :value="info.expectDate"
								@change="timeChange" />
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="备注">
							<a-input v-model="info.remark" placeholder="请输入"></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-table :data-source="info.bizGoodsInfos" bordered :pagination="false">
						<a-table-column key="index" title="序号" data-index="index" width="70px">
							<template scope="text, record, index">{{ index + 1 }}</template>
						</a-table-column>
						<a-table-column key="name" title="* 物品名称" class="note" data-index="name">
							<template slot-scope="text, record">
								<a-input v-model="record.name" placeholder="请输入"></a-input>
							</template>
						</a-table-column>
						<a-table-column key="model" title="* 规格型号" class="note" data-index="model">
							<template slot-scope="text, record">
								<a-input v-model="record.model" placeholder="请输入"></a-input>
							</template>
						</a-table-column>
						<a-table-column key="amount" title="* 数量" class="note" data-index="amount">
							<template slot-scope="text, record">
								<a-input v-model="record.amount" placeholder="请输入"></a-input>
							</template>
						</a-table-column>
						<a-table-column key="unit" title="* 单位" class="note" data-index="unit">
							<template slot-scope="text, record">
								<a-input v-model="record.unit" placeholder="请输入"></a-input>
							</template>
						</a-table-column>
						<a-table-column key="remark" title="备注" data-index="remark">
							<template slot-scope="text, record">
								<a-input v-model="record.remark" placeholder="请输入"></a-input>
							</template>
						</a-table-column>
						<a-table-column key="usages" title="* 使用部门" class="note" data-index="usages" width="200px">
							<template slot-scope="text, record">
								<a-select allowClear placeholder="请选择" v-model="record.usages">
									<a-select-option :value="item.dept_id" v-for="(item, index) in deptlist"
										:key="index">
										{{ item.dept_name }}
									</a-select-option>
								</a-select>
							</template>
						</a-table-column>
						<a-table-column key="action" title="操作" data-index="action" width="70px">
							<template scope="text,record,index">
								<a @click="removei(index)">删除</a>
							</template>
						</a-table-column>
					</a-table>
				</a-row>
				<a-row>
					<div class="btn_last">
						<a-button type="primary" @click="add_detail">
							<a-icon type="plus" />添加
						</a-button>
					</div>
				</a-row>
			</a-form-model>
		</a-modal>
		<a-modal title="合同审批重新提交" :visible="is_show_apply" @cancel="is_show_apply = false" width="70%"
			:maskClosable="false">
			<template slot="footer">
				<a-button key="back" @click="is_show_apply = false"> 取消 </a-button>
				<a-button key="submit" type="primary" @click="contractOk"> 提交 </a-button>
			</template>
			<a-form-model :model="form" ref="htruleForm" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
				<a-row>
					<a-form-item label="选择抄送人" :label-col="labelCol2" :wrapper-col="wrapperCol2">
						<ccChange :data="ccC" :money="moneY" @targetKeys="applygetdata" v-if="isRouterAlive" />
					</a-form-item>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="审批编号">
							<a-input v-model="form.applyCode" disabled></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="合同编号" prop="contractCode">
							<a-input v-model="form.contractCode" allowClear placeholder="请输入"></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="合同名称" prop="contractName">
							<a-input v-model="form.contractName" allowClear placeholder="请输入"></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="客户名称" prop="customerName">
							<a-input v-model="form.customerName" allowClear placeholder="请输入"></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="合同日期" prop="contractDate">
							<a-date-picker valueFormat="YYYY-MM-DD" style="width: 285px" allowClear
								v-model="form.contractDate" placeholder="请输入" />
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="项目名称" prop="projectName">
							<a-input v-model="form.projectName" allowClear placeholder="请输入"></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="项目编号" prop="projectCode">
							<a-input v-model="form.projectCode" allowClear placeholder="请输入"></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="到期日期" prop="expiryDate">
							<a-date-picker valueFormat="YYYY-MM-DD" style="width: 285px" allowClear
								v-model="form.expiryDate" placeholder="请选择" />
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="合同金额(元)" prop="contractAmount">
							<a-input v-model="form.contractAmount" @input="contractAmountchange" allowClear
								placeholder="请输入" oninput="value=value.replace(/[^\d.]/g,'')"></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="客户联系人" prop="customerContact">
							<a-input v-model="form.customerContact" allowClear placeholder="请输入"></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="联系方式" prop="contactInformation">
							<a-input v-model="form.contactInformation" allowClear placeholder="请输入"></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="跟进人部门" prop="followerDept">
							<a-cascader :options="options" placeholder="请选择" @change="onChangeDept" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="跟进人" prop="follower">
							<a-select style="width: 100%" :disabled="!form.followerDept" allowClear
								v-model="form.follower" placeholder="请选择">
								<a-select-option :value="item.value" v-for="(item, index) in followers" :key="index">
									{{ item.label }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="图片">
							<uploadImgJava :data="uploadDataImg" v-if="isRouterAlive" />
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="附件">
							<uploadFileCode :data="uploadData" v-if="isRouterAlive" />
						</a-form-model-item>
					</a-col>
				</a-row>
			</a-form-model>
		</a-modal>
		<a-modal title="报销申请重新提交" :visible="reimburse_visible" @cancel="reimburseClose" @ok="reimburseOk" width="70%"
			:maskClosable="false">
			<a-form-model :model="reimburseform" ref="bxruleForm" :rules="rules" :label-col="labelCol4"
				:wrapper-col="wrapperCol4">
				<a-row style="margin-bottom: 15px"><span class="form_title">表单信息</span></a-row>
				<a-row>
					<a-form-model-item label="选择抄送人" :label-col="labelCol2" :wrapper-col="wrapperCol2">
						<ccChange :data="ccC" :money="moneY" @targetKeys="reimbursegetdata" v-if="isRouterAlive" />
					</a-form-model-item>
				</a-row>
				<a-row>
					<!-- <a-col :span="8">
						<a-form-model-item label="关联审批单类型">
							<a-select show-search allowClear class="margin_self" v-model="form.reimburseType" @change="changeauditCode" placeholder="请输入">
								<a-select-option :value="item.id" v-for="(item, index) in Approvallist" :key="index">
									{{ item.name }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col> -->
					<a-col :span="24">
						<a-form-model-item label="关联审批单" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
							<a-select show-search allowClear style="width: 200px; margin-right: 20px;"
								v-model="approvalId" placeholder="关联审批单类型">
								<a-select-option :value="item.id" v-for="(item, index) in companyList1" :key="index">
									{{ item.name }}
								</a-select-option>
							</a-select>
							<!-- <a-button type="primary" @click="showAuditCode"> 关联 </a-button> -->
							<a-button type="primary" @click="showAuditCode" :disabled="approvalId == undefined"> 关联报销
							</a-button>
							<a-button type="primary" @click="showPurchase"> 关联采购 </a-button>
							<!-- <a-input allowClear v-model="form.auditCode" @click="showAuditCode" :disabled="!form.reimburseType" placeholder="请输入"></a-input> -->
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="审批单" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
							<div>
								<span v-for="(item, index) in auditCodeData" :key="index" class="auditItem">
									<span @click="handelAudit(index)">{{ item.processName }}</span>
									<a-icon class="close_icon2" @click="delete_auditCode(index)" type="close" />
								</span>
								<span v-for="(item, index) in auditCodeData2" :key="index" class="auditItem">
									<span @click="handelAudit2(index)">{{ item.title }}</span>
									<a-icon class="close_icon2" @click="delete_auditCode2(index)" type="close" />
								</span>
								<span v-for="(item, index) in auditCodeData3" :key="index" class="auditItem">
									<span @click="handelAudit3(index)">{{ item.title }}</span>
									<a-icon class="close_icon2" @click="delete_auditCode3(index)" type="close" />
								</span>
								<span v-for="(item, index) in auditCodeData4" :key="index" class="auditItem">
									<span @click="handelAudit4(index)">{{ item.title }}</span>
									<a-icon class="close_icon2" @click="delete_auditCode4(index)" type="close" />
								</span>
							</div>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="费用归属部门" prop="subjectionDeptId">
							<a-select allowClear placeholder="请选择" v-model="reimburseform.subjectionDeptId"
								style="width: 267px;">
								<a-select-option :value="item.dept_id" v-for="(item, index) in deptlist" :key="index">
									{{ item.dept_name }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row v-for="(item, index) in reimburseform.reimburseDetails" :key="index">
					<a-row>
						<div class="pay_top">
							<span class="form_title">报销明细{{ index + 1 }}</span>
							<a-icon class="close_icon" @click="close_detail(index)"
								v-if="reimburseform.reimburseDetails.length > 1" type="close" />
						</div>
					</a-row>
					<a-row>
						<a-col :span="8">
							<a-form-model-item label="费用发生日期" :prop="'reimburseDetails.' + index + '.expenseTime'"
								:rules="{
									required: true,
									message: '请选择费用发生日期',
									trigger: 'change',
								}">
								<a-date-picker v-model="reimburseform.reimburseDetails[index].expenseTime"
									valueFormat="YYYY-MM-DD" allowClear style="width: 267px" />
							</a-form-model-item>
						</a-col>
						<a-col :span="8">
							<a-form-model-item label="报销类别" :prop="'reimburseDetails.' + index + '.types'" :rules="{
								required: true,
								message: '请选择报销类别',
								trigger: 'change',
							}">
								<a-select show-search allowClear class="margin_self"
									v-model="reimburseform.reimburseDetails[index].types" placeholder="请输入">
									<a-select-option :value="item.value" v-for="(item, index) in typesType"
										:key="index">
										{{ item.label }}
									</a-select-option>
								</a-select>
							</a-form-model-item>
						</a-col>
						<a-col :span="8">
							<a-form-model-item label="报销金额(元)" :prop="'reimburseDetails.' + index + '.money'" :rules="{
								required: true,
								message: '请填写报销金额(元)',
								trigger: 'blur',
							}">
								<a-input v-model="reimburseform.reimburseDetails[index].money" type="number"
									@change="changeMoneyTotal" placeholder="请输入"></a-input>
							</a-form-model-item>
						</a-col>
					</a-row>
					<a-row>
						<a-col :span="24">
							<a-form-model-item label="费用明细" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }"
								:prop="'reimburseDetails.' + index + '.remark'" :rules="{
									required: true,
									message: '请填写费用明细',
									trigger: 'blur',
								}">
								<a-textarea :auto-size="{ minRows: 3, maxRows: 3 }"
									v-model="reimburseform.reimburseDetails[index].remark" placeholder="请输入" />
							</a-form-model-item>
						</a-col>
					</a-row>
					<a-row>
						<a-col :span="24">
							<a-form-model-item label="发票号码" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }"
								:prop="'reimburseDetails.' + index + '.invoice'" :rules="{
									required: true,
									message: '请填写电子发票',
									trigger: 'blur',
								}">
								<a-textarea :auto-size="{ minRows: 3, maxRows: 3 }"
									v-model="reimburseform.reimburseDetails[index].invoice" placeholder="请输入" />
							</a-form-model-item>
						</a-col>
					</a-row>
				</a-row>
				<a-row>
					<div class="btn_last">
						<a-button type="primary" @click="add_detail2"> 新增报销明细 </a-button>
					</div>
				</a-row>
				<a-row style="margin-bottom: 15px"><span class="form_title">表单信息</span></a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="报销总金额" prop="reimburseMoneyTotal">
							<a-input disabled v-model="reimburseform.reimburseMoneyTotal" placeholder="请输入"></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="备注">
							<a-textarea v-model="reimburseform.remark" placeholder="请输入"
								:auto-size="{ minRows: 1, maxRows: 3 }" />
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="特殊备注">
							<a-textarea v-model="reimburseform.remarkSpec" placeholder="不能打印"
								:auto-size="{ minRows: 1, maxRows: 3 }" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="报销凭证" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
							<uploadImgJava :data="uploadDataImg" v-if="isRouterAlive" />
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="附件" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
							<uploadFileCode :data="uploadData" v-if="isRouterAlive" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="收款账号" prop="accountNum">
							<a-select allowClear class="margin_self" v-model="reimburseform.accountNum"
								@change="changeform($event)" @dropdownVisibleChange="changeT" @blur="changeF"
								placeholder="请输入">
								<div slot="dropdownRender" slot-scope="menu">
									<v-nodes :vnodes="menu" />
									<a-divider style="margin: 4px 0;" />
									<div style="padding: 4px 8px; cursor: pointer;color: #1890FF;"
										@mousedown="e => e.preventDefault()" @click="alert">
										<a-icon type="plus" /> 添加新收款账号
									</div>
								</div>
								<a-select-option :value="item.accountNum" v-for="(item, index) in banklist"
									:key="index">
									<span style="font-weight: 700;">
										{{ item.name }}
									</span>
									{{ item.bank }} {{ item.accountNum }}
									<span style="float: right;color: #1890FF;" v-show="bankshow"
										@click="bankclear(item.id)">清除</span>
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
				</a-row>
			</a-form-model>
		</a-modal>
		<a-modal title="付款申请重新提交" :visible="payment_visible" @cancel="paymentClose" width="70%" :maskClosable="false">
			<template slot="footer">
				<a-button key="back" @click="paymentClose"> 取消 </a-button>
				<a-button key="submit" type="primary" @click="paymentOk"> 提交 </a-button>
			</template>
			<a-form-model :model="paymentform" :rules="rules" ref="fkruleForm" :label-col="labelCol4"
				:wrapper-col="wrapperCol4">
				<a-row style="margin-bottom: 15px"><span class="form_title">表单信息</span></a-row>
				<a-row>
					<a-form-model-item label="选择抄送人" :label-col="labelCol2" :wrapper-col="wrapperCol2">
						<ccChange :data="ccC" :money="moneY" @targetKeys="paymentgetdata" v-if="isRouterAlive" />
					</a-form-model-item>
				</a-row>
				<a-row>
					<!-- <a-col :span="8">
						<a-form-model-item label="关联审批单类型">
							<a-select show-search allowClear class="margin_self" v-model="form.reimburseType" @change="changeauditCode" placeholder="请输入">
								<a-select-option :value="item.id" v-for="(item, index) in Approvallist" :key="index">
									{{ item.name }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col> -->
					<a-col :span="24">
						<a-form-model-item label="关联审批单" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
							<a-select show-search allowClear style="width: 200px; margin-right: 20px;"
								v-model="approvalId" placeholder="关联审批单类型">
								<a-select-option :value="item.id" v-for="(item, index) in companyList1" :key="index">
									{{ item.name }}
								</a-select-option>
							</a-select>
							<!-- <a-button type="primary" @click="showAuditCode"> 关联 </a-button> -->
							<a-button type="primary" @click="showAuditCode" :disabled="approvalId == undefined"> 关联报销
							</a-button>
							<a-button type="primary" @click="showPurchase1"> 关联采购 </a-button>
							<!-- <a-input allowClear v-model="form.auditCode" @click="showAuditCode" :disabled="!form.reimburseType" placeholder="请输入"></a-input> -->
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="审批单" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
							<div>
								<span v-for="(item, index) in auditCodeData" :key="index" class="auditItem">
									<span @click="handelAudit(index)">{{ item.processName }}</span>
									<a-icon class="close_icon2" @click="delete_auditCode(index)" type="close" />
								</span>
								<span v-for="(item, index) in auditCodeData2" :key="index" class="auditItem">
									<span @click="handelAudit2(index)">{{ item.title }}</span>
									<a-icon class="close_icon2" @click="delete_auditCode2(index)" type="close" />
								</span>
								<span v-for="(item, index) in auditCodeData3" :key="index" class="auditItem">
									<span @click="handelAudit3(index)">{{ item.title }}</span>
									<a-icon class="close_icon2" @click="delete_auditCode3(index)" type="close" />
								</span>
								<span v-for="(item, index) in auditCodeData4" :key="index" class="auditItem">
									<span @click="handelAudit4(index)">{{ item.title }}</span>
									<a-icon class="close_icon2" @click="delete_auditCode4(index)" type="close" />
								</span>
							</div>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="付款类别" prop="projectType">
							<a-select style="width: 100%" v-model="paymentform.projectType" placeholder="请选择">
								<a-select-option :value="index" v-for="(item, index) in payMentTypes" allowClear
									:key="index">
									{{ item }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="隶属公司" prop="companyId">
							<a-select allowClear placeholder="隶属公司" v-model="paymentform.companyId"
								@change="handlecompanyplan">
								<a-select-option :value="item.deptId" v-for="(item, index) in companylist2"
									:key="index">
									{{ item.title }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="隶属部门" prop="subjectionDeptId">
							<a-select allowClear placeholder="隶属部门" :disabled="!paymentform.companyId"
								v-model="paymentform.subjectionDeptId" @change="changeDept">
								<a-select-option :value="item.deptId" v-for="(item, index) in deptlist2" :key="index">
									{{ item.title }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="项目名称" prop="projectName">
							<a-input v-model="paymentform.projectName" allowClear placeholder="请输入"></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="项目编号" prop="projectCode">
							<a-input v-model="paymentform.projectCode" allowClear placeholder="请输入"></a-input>
						</a-form-model-item>
					</a-col>


					<a-col :span="8">
						<a-form-model-item label="已付金额" prop="paidCount">
							<a-input v-model="paymentform.paidCount" type="number" allowClear placeholder="请输入">
							</a-input>
						</a-form-model-item>
					</a-col>
					<!-- <a-col :span="8">
		    <a-form-model-item label="抄送人部门">
		      <a-cascader :options="options" placeholder="请选择" @change="onChangeDeptCc" />
		    </a-form-model-item>
		  </a-col>
		  <a-col :span="8">
		    <a-form-model-item label="抄送人" prop="ccIds">
		      <a-select
		        mode="multiple"
		        v-model="form.ccIds"
		        style="width: 100%"
		        :disabled="!form.ccDeptId"
		        placeholder="请选择"
		        allowClear
		        @change="handleChange"
		      >
		        <a-select-option v-for="(item, index) in ccs" :value="item.value" :key="index">
		          {{ item.label }}
		        </a-select-option>
		      </a-select>
		    </a-form-model-item>
		  </a-col> -->
					<a-col :span="8">
						<a-form-model-item label="项目总金额" prop="projectMoney">
							<a-input v-model="paymentform.projectMoney" type="number" allowClear placeholder="请输入">
							</a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row v-for="(item, index) in paymentform.paymentDetails" :key="index">
					<a-row>
						<div class="pay_top">
							<span class="form_title">付款明细{{ index + 1 }}</span>
							<a-icon class="close_icon" @click="close_detail2(index)"
								v-if="paymentform.paymentDetails.length > 1" type="close" />
						</div>
					</a-row>
					<a-row>
						<a-col :span="8">
							<a-form-model-item label="本次支付金额" :prop="'paymentDetails.' + index + '.thisPayment'" :rules="{
								required: true,
								message: '请填写本次支付金额',
								trigger: 'blur',
							}">
								<a-input v-model="item.thisPayment" type="number" @input="inputEnter" allowClear
									placeholder="请输入"></a-input>
							</a-form-model-item>
						</a-col>
					</a-row>
					<a-row>
						<a-col :span="24">
							<a-form-model-item label="电子发票" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
								<a-textarea :auto-size="{ minRows: 3, maxRows: 3 }" v-model="item.invoice" allowClear
									placeholder="请输入" />
							</a-form-model-item>
						</a-col>
					</a-row>
					<a-row>
						<a-col :span="24">
							<a-form-model-item label="费用明细" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
								<a-textarea :auto-size="{ minRows: 3, maxRows: 3 }" v-model="item.remark" allowClear
									placeholder="请输入" />
							</a-form-model-item>
						</a-col>
					</a-row>
				</a-row>
				<a-row>
					<div class="btn_last">
						<a-button type="primary" @click="add_detail3"> 新增付款明细 </a-button>
					</div>
				</a-row>

				<a-row>
					<a-col :span="8">
						<a-form-model-item label="本次付款总金额" prop="payCount">
							<a-input v-model="paymentform.payCount" type="number" disabled allowClear placeholder="请输入">
							</a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row style="margin-bottom: 15px"><span class="form_title">表单信息</span></a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="特殊备注" prop="remarkSpec">
							<a-textarea :auto-size="{ minRows: 1, maxRows: 3 }" v-model="paymentform.remarkSpec"
								allowClear placeholder="请输入" />
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="备注" prop="remark">
							<a-textarea :auto-size="{ minRows: 1, maxRows: 3 }" v-model="paymentform.remark" allowClear
								placeholder="请输入" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="付款凭证" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
							<uploadImgJava :data="uploadDataImg" v-if="isRouterAlive" />
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="附件" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
							<uploadFileCode :data="uploadData" v-if="isRouterAlive" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item prop="accountType" label="账户类型" :colon="false" :label-col="{ span: 6 }"
							:wrapper-col="{ span: 18 }">
							<selectUnitPay @getPayRow="getPay" v-if="isRouterAlive" />
						</a-form-model-item>
					</a-col>
				</a-row>
			</a-form-model>
		</a-modal>
		<a-modal title="业务费申请重新提交" :visible="operation_visible" @cancel="operation_visible = false" @ok="operationOk"
			width="60%" :maskClosable="false">
			<a-form-model :model="operationform" ref="ywfruleForm" :rules="rules" :labelCol="labelCol3"
				:wrapperCol="wrapperCol3">
				<a-row>
					<a-col :span="12">
						<a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol">
							<span class="spanClass" style="font-size: 16px; font-weight: 700; color: gray">表单信息</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-form-model-item label="选择抄送人" :label-col="labelCol2" :wrapper-col="wrapperCol2">
						<ccChange :data="ccC" :money="moneY" @targetKeys="operationgetdata" v-if="isRouterAlive" />
					</a-form-model-item>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="隶属公司" prop="companyId" :rules="{
							required: true,
							message: '请选择隶属公司',
							trigger: 'change',
						}">
							<a-select allowClear placeholder="隶属公司" @change="handlecompanyplan"
								v-model="operationform.companyId">
								<a-select-option :value="item.dept_id" v-for="(item, index) in companylist2"
									:key="index">
									{{ item.dept_name }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="隶属部门" prop="applyDeptId" :rules="{
							required: true,
							message: '请选择隶属部门',
							trigger: 'change',
						}">
							<a-select allowClear v-model="operationform.applyDeptId"
								:disabled="!operationform.companyId" placeholder="隶属部门" @change="leaderid($event)">
								<a-select-option :value="item.dept_id" v-for="(item, index) in deptlist2" :key="index">
									{{ item.dept_name }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="申请人" prop="applyUser" :rules="{
							required: true,
							message: '请选择申请人',
							trigger: 'change',
						}">
							<a-select show-search allowClear class="margin_self" v-model="operationform.applyUser"
								:disabled="!operationform.applyDeptId" placeholder="申请人">
								<a-select-option :value="item.loginName" v-for="(item, index) in plainOptions"
									:key="index">
									{{ item.userName }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="项目编号">
							<a-input allowClear v-model="operationform.projectCode" placeholder="项目编号" />
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="项目名称" prop="projectName" :rules="{
							required: true,
							message: '请输入项目名称',
							trigger: 'change',
						}">
							<a-input allowClear v-model="operationform.projectName" placeholder="项目名称" />
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="项目总金额" prop="projectPrice" :rules="{
							required: true,
							message: '请输入项目总金额',
							trigger: 'change',
						}">
							<a-input allowClear @input="projectPricechange" v-model="operationform.projectPrice"
								placeholder="项目总金额" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="支付对象" prop="paymentObject" :rules="{
							required: true,
							message: '请输入支付对象',
							trigger: 'change',
						}">
							<a-input allowClear v-model="operationform.paymentObject" placeholder="支付对象" />
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="新老业务" prop="ifOld" :rules="{
							required: true,
							message: '请选择新老业务！',
							trigger: 'change',
						}">
							<a-select allowClear class="margin_self"  v-model="operationform.ifOld"
							 placeholder="点击选择">
								<a-select-option value="0">新业务</a-select-option>
								<a-select-option value="1">续签业务</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="备注">
							<a-textarea :auto-size="{ minRows: 1, maxRows: 3 }" allowClear
								v-model="operationform.remark" placeholder="备注" />
						</a-form-model-item>
					</a-col>
					
				</a-row>
				<a-row>
					
					<a-col :span="8">
						<a-form-item label="业务费" prop="commission" :rules="{
							required: true,
							message: '请选择业务费',
							trigger: 'change',
						}">
							<a-input type="number" allowClear v-model="operationform.commission" placeholder="业务费"  />
						</a-form-item>
					</a-col>
					<a-col :span="8">
						<a-form-item label="分包费" prop="subprojectFee" :rules="{
							required: true,
							message: '请选择分包费',
							trigger: 'change',
						}">
							<a-input type="number" allowClear v-model="operationform.subprojectFee" placeholder="分包费" />
						</a-form-item>
					</a-col>
					<a-col :span="8">
						<a-form-item label="其他费用" prop="otherFee" :rules="{
							required: true,
							message: '请选择其他费用',
							trigger: 'change',
						}">
							<a-input type="number" allowClear v-model="operationform.otherFee" placeholder="其他费用"  />
						</a-form-item>
					</a-col>
					
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="报价单">
							<uploadFileCode :data="uploadData" v-if="isRouterAlive" />
						</a-form-model-item>
					</a-col>
				</a-row>
			</a-form-model>
		</a-modal>
		<a-modal title="领用申请重新提交" v-model="is_apply_show" width="60%" :maskClosable="false">
			<template slot="footer">
				<a-button key="back" @click="is_apply_show = false"> 取消 </a-button>
				<a-button key="submit" type="primary" @click="apply_delivery"> 领用出库 </a-button>
			</template>
			<a-form-model :rules="rules" ref="lyruleForm" :model="receiveform" :label-col="labelCol"
				:wrapper-col="wrapperCol">
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="物品用途" prop="reason" :rules="{
							required: true,
							message: '请输入物品用途',
							trigger: 'change',
						}">
							<a-textarea v-model="receiveform.reason" placeholder="如:日常办公"
								:auto-size="{ minRows: 1, maxRows: 3 }" />
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="备　　注">
							<a-textarea v-model="receiveform.remark" placeholder="请输入领用物品的详细说明"
								:auto-size="{ minRows: 1, maxRows: 3 }" />
						</a-form-model-item>
					</a-col>

				</a-row>
				<a-row>
					<a-form-model-item label="选择抄送人" :label-col="labelCol2" :wrapper-col="wrapperCol2">
						<ccChange :data="ccC" @targetKeys="receivegetdata" v-if="isRouterAlive" />
					</a-form-model-item>
				</a-row>
				<a-row>
					<a-table :data-source="receiveform.goods" bordered :pagination="false">
						<a-table-column key="name" title="物品名称" data-index="name">
							<template scope="text,record">{{ record.aaSpu.name }}</template>
						</a-table-column>
						<a-table-column key="model" title="规格型号" data-index="model">
							<template scope="text,record">{{ record.aaSpu.model }}</template>
						</a-table-column>
						<a-table-column key="isInspected" title="是否检定" data-index="isInspected">
							<template scope="text,record">
								<span :style="{ color: colors[record.aaSpu.isInspected] }">{{
										instrumentMap[record.aaSpu.isInspected]
								}}</span>
							</template>
						</a-table-column>
						<a-table-column key="claimNum" title="申领数量" data-index="claimNum" width="200px">
							<template scope="text,record">
								<a-input v-model="record.claimNum" />
							</template>
						</a-table-column>
						<a-table-column key="unit" title="物品单位" data-index="unit">
							<template scope="text,record">{{ record.aaSpu.unit }}</template>
						</a-table-column>
					</a-table>
				</a-row>
			</a-form-model>
		</a-modal>
		<a-modal title="退货出库重新提交" v-model="return_visible" width="60%" :maskClosable="false">
			<template slot="footer">
				<a-button key="back" @click="return_visible = false"> 取消 </a-button>
				<a-button key="submit" type="primary" @click="returnOk"> 提交 </a-button>
			</template>
			<a-form-model :rules="rules" ref="thruleForm" :model="returnform" :label-col="labelCol3"
				:wrapper-col="wrapperCol3">
				<a-row>
					<a-form-model-item label="选择抄送人" :label-col="labelCol2" :wrapper-col="wrapperCol2">
						<ccChange :data="ccC" @targetKeys="returngetdata" v-if="isRouterAlive" />
					</a-form-model-item>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="退货原因" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }"
							prop="returnReason" :rules="{
								required: true,
								message: '请输入退货原因',
								trigger: 'change',
							}">
							<a-input v-model="returnform.returnReason" placeholder="请输入"></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="报销凭证" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
							<uploadImgJava :data="uploadDataImg" v-if="isRouterAlive" />
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="附件" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
							<uploadFileCode :data="uploadData" v-if="isRouterAlive" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-table :data-source="returnform.goodsRejectedDetailList" bordered :pagination="false">
						<a-table-column key="purchaseCode" title="采购编号" ellipsis="true" data-index="purchaseCode" />
						<a-table-column key="assetSn" title="物品编号" ellipsis="true" data-index="assetSn">
							<template scope="text,record">{{ record.asset.assetSn }}</template>
						</a-table-column>
						<a-table-column key="name" title="物品名称" ellipsis="true" data-index="name">
							<template scope="text,record">{{ record.asset.name }}</template>
						</a-table-column>
						<a-table-column key="model" title="规格型号" ellipsis="true" data-index="model">
							<template scope="text,record">{{ record.asset.model }}</template>
						</a-table-column>
						<a-table-column key="num" title="退货数量" data-index="num" width="200px">
							<template scope="text,record">
								<a-input v-model="record.num" type="number" @blur="set_max_min(record)"
									:disabled="key == 1" />
							</template>
						</a-table-column>
						<a-table-column key="unit" title="单位" ellipsis="true" data-index="unit">
							<template scope="text,record">{{ record.asset.unit }}</template>
						</a-table-column>
						<a-table-column key="remarks" title="备注" data-index="remarks" width="200px">
							<template scope="text,record">
								<a-input v-model="record.remarks" />
							</template>
						</a-table-column>
						<!-- <a-table-column key="action" title="操作" data-index="action">
								<template scope="text,record">
									<a @click="deletes(record)">删除</a>
								</template>
							</a-table-column> -->
					</a-table>
				</a-row>
			</a-form-model>
		</a-modal>
		<a-modal title="评审费申请重新提交" v-model="service_visit" @ok="serviceOk" width="60%" :maskClosable="false">
			<a-form-model ref="psruleForm" :rules="rules" :model="serviceform" :labelCol="labelCol3"
				:wrapperCol="wrapperCol3">
				<a-row>
					<a-col :span="12">
						<a-form-model-item>
							<span class="spanClass" style="font-size: 16px; font-weight: 700;color: gray;">表单信息</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-form-model-item label="选择抄送人" :label-col="labelCol2" :wrapper-col="wrapperCol2">
						<ccChange :data="ccC" :money="moneY" @targetKeys="servicegetdata" v-if="isRouterAlive" />
					</a-form-model-item>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="隶属公司" prop="companyId">
							<a-select allowClear placeholder="隶属公司" @change="serhandlecompanyplan"
								v-model="serviceform.companyId">
								<a-select-option :value="item.deptId" v-for="(item, index) in companylist2"
									:key="index">
									{{ item.title }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="隶属部门" prop="deptId">
							<a-select allowClear v-model="serviceform.deptId" placeholder="隶属部门"
								:disabled="!this.serviceform.companyId">
								<a-select-option :value="item.deptId" v-for="(item, index) in deptlist" :key="index">
									{{ item.title }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="款项用途" prop="types">
							<a-select allowClear placeholder="款项用途" disabled @change="typesChange"
								v-model="serviceform.types">
								<a-select-option :value="index" v-for="(item, index) in typesMap" :key="index">
									{{ item }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="付款事由" prop="paymentDetails">
							<a-input allowClear v-model="serviceform.paymentDetails" placeholder="付款事由" />
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="付款方式" prop="paymentMode">
							<a-select allowClear placeholder="付款方式" v-model="serviceform.paymentMode">
								<a-select-option :value="index" v-for="(item, index) in paymentMap" :key="index">
									{{ item }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="支付日期">
							<a-date-picker valueFormat="YYYY-MM-DD" allowClear v-model="serviceform.paymentDate"
								placeholder="支付日期" style="width: 243px" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="支付对象" prop="paymentObject">
							<a-input allowClear v-model="serviceform.paymentObject" placeholder="支付对象" />
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="开户行" prop="bankOfDeposit">
							<a-input allowClear v-model="serviceform.bankOfDeposit" placeholder="开户行" />
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="银行账户" prop="bankAccount">
							<a-input allowClear v-model="serviceform.bankAccount" placeholder="银行账户" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="特殊备注">
							<a-textarea :auto-size="{ minRows: 1, maxRows: 3 }" allowClear v-model="serviceform.remark"
								placeholder="不能打印" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<div v-if="serviceform.types == 1" v-for="(item, index) in serviceform.bizReviewInfos" :key="index">
					<a-row>
						<div class="pay_top">
							<span class="form_title" style="font-size: 16px; font-weight: 700;color: gray;">评审费{{ index
									+ 1
							}}</span>
							<a-icon class="close_icon" @click="close_detaile(index)"
								v-if="serviceform.bizReviewInfos.length > 1" type="close" />
						</div>
					</a-row>
					<a-row>
						<a-col :span="8">
							<a-form-model-item label="项目编号" :prop="'bizReviewInfos.' + index + '.projectCode'" :rules="{
								required: true,
								message: '请输入项目编号',
								trigger: 'blur',
							}">
								<a-input allowClear v-model="serviceform.bizReviewInfos[index].projectCode"
									placeholder="项目编号" />
							</a-form-model-item>
						</a-col>
						<a-col :span="8">
							<a-form-model-item label="项目负责人" :prop="'bizReviewInfos.' + index + '.projectUser'" :rules="{
								required: true,
								message: '请输入项目负责人',
								trigger: 'blur',
							}">
								<a-input allowClear v-model="serviceform.bizReviewInfos[index].projectUser"
									placeholder="项目负责人" />
							</a-form-model-item>
						</a-col>
						<a-col :span="8">
							<a-form-model-item label="客户名称" :prop="'bizReviewInfos.' + index + '.inspectedUnit'" :rules="{
								required: true,
								message: '请输入客户名称',
								trigger: 'blur',
							}">
								<a-input allowClear v-model="serviceform.bizReviewInfos[index].inspectedUnit"
									placeholder="客户名称" />
							</a-form-model-item>
						</a-col>
					</a-row>
					<a-row>
						<a-col :span="8">
							<a-form-model-item label="评审日期" :prop="'bizReviewInfos.' + index + '.reviewDate'" :rules="{
								required: true,
								message: '请选择评审日期',
								trigger: 'change',
							}">
								<a-date-picker valueFormat="YYYY-MM-DD" allowClear
									v-model="serviceform.bizReviewInfos[index].reviewDate" placeholder="评审日期"
									style="width: 243px" />
							</a-form-model-item>
						</a-col>
						<a-col :span="8">
							<a-form-model-item label="实际评审日期">
								<a-date-picker valueFormat="YYYY-MM-DD" allowClear
									v-model="serviceform.bizReviewInfos[index].actualReviewDate" placeholder="实际评审日期"
									style="width: 243px" />
							</a-form-model-item>
						</a-col>
						<a-col :span="8">
							<a-form-model-item label="评审费金额(元)" :prop="'bizReviewInfos.' + index + '.reviewAmount'"
								:rules="{
									required: true,
									message: '请输入评审费金额(元)',
									trigger: 'blur',
								}">
								<a-input allowClear type="number"
									v-model="serviceform.bizReviewInfos[index].reviewAmount"
									@change="serchangeMoneyTotal" placeholder="评审费金额" />
							</a-form-model-item>
						</a-col>
					</a-row>
					<a-row>
						<a-col :span="8">
							<a-form-model-item label="专家人数" :prop="'bizReviewInfos.' + index + '.expertNum'" :rules="{
								required: true,
								message: '请输入专家人数',
								trigger: 'blur',
							}">
								<a-input allowClear type="number" v-model="serviceform.bizReviewInfos[index].expertNum"
									placeholder="专家人数" />
							</a-form-model-item>
						</a-col>
						<a-col :span="8">
							<a-form-model-item label="备注">
								<a-input allowClear v-model="serviceform.bizReviewInfos[index].remark"
									placeholder="备注" />
							</a-form-model-item>
						</a-col>
					</a-row>
				</div>
				<a-row v-if="serviceform.types == 1">
					<div class="btn_last">
						<a-button type="primary" @click="seradd_detail"> 新增评审费明细 </a-button>
					</div>
				</a-row>
				<div v-if="serviceform.types == 2" v-for="(item, index) in serviceform.bizReviewInfos" :key="index">
					<a-row>
						<div class="pay_top">
							<span class="form_title" style="font-size: 16px; font-weight: 700;color: gray;">服务费{{ index
									+ 1
							}}</span>
							<a-icon class="close_icon" @click="close_service(index)"
								v-if="serviceform.bizReviewInfos.length > 1" type="close" />
						</div>
					</a-row>
					<a-row>
						<a-col :span="8">
							<a-form-model-item label="项目编号" :prop="'bizReviewInfos.' + index + '.projectCode'" :rules="{
								required: true,
								message: '请输入项目编号',
								trigger: 'blur',
							}">
								<a-input allowClear v-model="serviceform.bizReviewInfos[index].projectCode"
									placeholder="项目编号" />
							</a-form-model-item>
						</a-col>
						<a-col :span="8">
							<a-form-model-item label="受检单位" :prop="'bizReviewInfos.' + index + '.inspectedUnit'" :rules="{
								required: true,
								message: '请输入受检单位',
								trigger: 'blur',
							}">
								<a-input allowClear v-model="serviceform.bizReviewInfos[index].inspectedUnit"
									placeholder="受检单位" />
							</a-form-model-item>
						</a-col>
						<a-col :span="8">
							<a-form-model-item label="合同金额(元)" :prop="'bizReviewInfos.' + index + '.contractAmount'"
								:rules="{
									required: true,
									message: '请输入合同金额(元)',
									trigger: 'blur',
								}">
								<a-input allowClear v-model="serviceform.bizReviewInfos[index].contractAmount"
									placeholder="合同金额" />
							</a-form-model-item>
						</a-col>
					</a-row>
					<a-row>
						<a-col :span="8">
							<a-form-model-item label="收款日期" :prop="'bizReviewInfos.' + index + '.amountDate'" :rules="{
								required: true,
								message: '请选择收款日期',
								trigger: 'change',
							}">
								<a-date-picker valueFormat="YYYY-MM-DD" allowClear
									v-model="serviceform.bizReviewInfos[index].amountDate" placeholder="收款日期"
									style="width: 243px" />
							</a-form-model-item>
						</a-col>
						<a-col :span="8">
							<a-form-model-item label="支付金额(元)" :prop="'bizReviewInfos.' + index + '.reviewAmount'"
								:rules="{
									required: true,
									message: '请输入支付金额(元)',
									trigger: 'blur',
								}">
								<a-input allowClear v-model="serviceform.bizReviewInfos[index].reviewAmount"
									@change="serchangeMoneyTotal" placeholder="支付金额" />
							</a-form-model-item>
						</a-col>
						<a-col :span="8">
							<a-form-model-item label="备注">
								<a-input allowClear v-model="serviceform.bizReviewInfos[index].remark"
									placeholder="备注" />
							</a-form-model-item>
						</a-col>
					</a-row>
				</div>
				<a-row v-if="serviceform.types == 2">
					<div class="btn_last">
						<a-button type="primary" @click="seradd_service"> 新增服务费明细 </a-button>
					</div>
				</a-row>
				<div v-if="serviceform.types == 3" v-for="(item, index) in serviceform.bizReviewInfos" :key="index">
					<a-row>
						<div class="pay_top">
							<span class="form_title" style="font-size: 16px; font-weight: 700;color: gray;">其他费用{{ index
									+ 1
							}}</span>
							<a-icon class="close_icon" @click="close_other(index)"
								v-if="serviceform.bizReviewInfos.length > 1" type="close" />
						</div>
					</a-row>
					<a-row>
						<a-col :span="8">
							<a-form-model-item label="费用明细" :prop="'bizReviewInfos.' + index + '.amountDetails'" :rules="{
								required: true,
								message: '请输入费用明细',
								trigger: 'blur',
							}">
								<a-input allowClear v-model="serviceform.bizReviewInfos[index].amountDetails"
									placeholder="费用明细" />
							</a-form-model-item>
						</a-col>
						<a-col :span="8">
							<a-form-model-item label="支付金额(元)" :prop="'bizReviewInfos.' + index + '.reviewAmount'"
								:rules="{
									required: true,
									message: '请输入支付金额(元)',
									trigger: 'blur',
								}">
								<a-input allowClear v-model="serviceform.bizReviewInfos[index].reviewAmount"
									@change="serchangeMoneyTotal" placeholder="支付金额" />
							</a-form-model-item>
						</a-col>
						<a-col :span="8">
							<a-form-model-item label="备注">
								<a-input allowClear v-model="serviceform.bizReviewInfos[index].remark"
									placeholder="备注" />
							</a-form-model-item>
						</a-col>
					</a-row>
				</div>
				<a-row v-if="serviceform.types == 3">
					<div class="btn_last">
						<a-button type="primary" @click="seradd_other"> 新增其他费用明细 </a-button>
					</div>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="总金额">
							<a-input disabled v-model="serviceform.amountTotal" placeholder="请输入"></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="附件" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
							<uploadImgJava :data="uploadDataImg" v-if="isRouterAlive" />
						</a-form-model-item>
					</a-col>
				</a-row>
			</a-form-model>
		</a-modal>
		<a-modal title="报废出库重新提交" v-model="scrap_visit" :closable="true" @cancel="cancelEvent"
			:confirm-loading="confirmLoading" width="1200px" :maskClosable="false">
			<template slot="footer">
				<a-button key="back" @click="cancelEvent"> 取消 </a-button>
				<a-button key="submit" type="primary" :loading="loading" @click="scrapOk"> 提交 </a-button>
			</template>
			<a-form-model ref="bfruleForm" :rules="scrapRules" :model="scrapform" :label-col="labelCol"
				:wrapper-col="wrapperCol">
				<a-row>
				   <a-col :span="12">
						<a-form-model-item label="报废残值价格" prop="scrappedPrice">
							<a-input v-model="scrapform.scrappedPrice" placeholder="请输入" oninput="value=value.match(/\d+\.?\d{0,2}/,'')" />
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="报废处理方式" prop="dealMethod">
							<a-input v-model="scrapform.dealMethod" placeholder="请输入" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="实际处理价格" prop="realPrice" >
							<a-input v-model="scrapform.realPrice" placeholder="请输入" oninput="value=value.match(/\d+\.?\d{0,2}/,'')" />
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="收款方式" prop="rcvMethod">
							<a-select show-search allowClear placeholder="选择收款方式" class="margin_self"
									v-model="scrapform.rcvMethod" style="width: 100%;">
									<a-select-option value="收现" >收现</a-select-option>
									<a-select-option value="转入企业银行">转入企业银行</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-col :span="24">
						<a-form-model-item label="报废原因" prop="remark"  :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
		                    <a-textarea :auto-size="{ minRows: 3, maxRows: 5 }" placeholder="请输入原因" v-model="scrapform.remark" />
							<!-- <a-input v-model="info.remark" placeholder="请输入" /> -->
						</a-form-model-item>
					</a-col>
						<!-- <a-form-model-item label="报废原因" prop="remark">
							<a-input v-model="scrapform.remark" placeholder="请输入" />
						</a-form-model-item> -->
					</a-col>
					<!-- <a-col :span="12">
						<a-form-model-item label="抄送人所在部门">
							<a-cascader :options="options" placeholder="请选择" @change="onChangeDept" />
						</a-form-model-item>
					</a-col> -->
				</a-row>
				<a-row>
					<a-form-model-item label="选择抄送人" :label-col="labelCol2" :wrapper-col="wrapperCol2">
						<ccChange :data="ccC" :money="moneY" @targetKeys="scrapgetdata" v-if="isRouterAlive" />
					</a-form-model-item>
					<!-- <a-col :span="12">
						<a-form-model-item label="选择抄送人" prop="cc">
							<a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange">
								全选
							</a-checkbox>
							<a-checkbox-group v-model="info.cc" :options="plainOptions" @change="onChangeFroup" />
						</a-form-model-item>
					</a-col> -->
					<!-- <a-col :span="12">
						<a-form-model-item label="报废原因" prop="remark">
							<a-input v-model="info.remark" placeholder="请输入" />
						</a-form-model-item>
					</a-col> -->
				</a-row>
				<a-input v-model="scrapPara.asset_sn" allowClear class="a_input_self margin_self"
					placeholder="请输入物品编码" />
				<a-input v-model="scrapPara.name" allowClear class="a_input_self margin_self" placeholder="请输入物品名称" />
				<a-button type="primary" style="margin: 10px" @click="scrapquery"> 查询 </a-button>
				<span><span style="color: red">* </span>请选择一项物品
					<span v-if="hasSelectedAssert" style="color: #f5222d"> 请选择报废物品</span></span>
				<a-table :columns="columns2" :data-source="data2" rowKey="id"
					:row-selection="{ selectedRowKeys: selectedRowKeys2, onChange: onSelectChange, type: 'radio' }"
					:pagination="pagination2" bordered @change="handleTableChange2">
					<span slot="asset_type" slot-scope="text">
						{{ text ? operTypeMap[text].text : '' }}
					</span>
					<span slot="state" slot-scope="text">
						<template>
							<a-tag :color="colors[text]">
								{{ text ? statusMap[text] : '' }}
							</a-tag>

						</template>
					</span>
					<span slot="dept_id" slot-scope="text">
						{{ text ? deptMap[text].text : '' }}
					</span>
				</a-table>
			</a-form-model>
		</a-modal>
		<a-modal title="用车申请重新提交" :visible="carvisible" @cancel="carvisible = false" :confirm-loading="confirmLoading"
			width="70%" :maskClosable="false">
			<template slot="footer">
				<a-button key="submit" type="primary" :loading="loading" @click="handleOkCar"> 提交 </a-button>
				<a-button key="back" @click="carvisible = false"> 取消 </a-button>
			</template>
			<a-form-model :model="carform" :rules="carrules" ref="ycruleForm" :label-col="labelCol4"
				:wrapper-col="wrapperCol4">
				<a-row style="margin-bottom: 15px"><span class="form_title">表单信息</span></a-row>
				<a-row>
					<a-form-model-item label="选择抄送人" :label-col="labelCol2" :wrapper-col="wrapperCol2">
						<ccChange :data="ccC" @targetKeys="getcardata" v-if="isRouterAlive" />
					</a-form-model-item>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="实际用车部门" prop="deptUseId">
							<a-tree-select allowClear :treeData="deptTree" placeholder="请输入" v-model="carform.deptUseId"
								treeDefaultExpandAll>
							</a-tree-select>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="司机预约" prop="isDriver">
							<a-select allowClear class="margin_self" v-model="carform.isDriver" placeholder="请输入">
								<a-select-option :value="item.value" v-for="(item, index) in driverType" :key="index">
									{{ item.label }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="预计出行日期" prop="goToDate">
							<a-date-picker v-model="carform.goToDate" allowClear style="width: 267px"
								:disabled-date="disabledDate" placeholder="出行日期" @change="changgTDate" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="预计回程日期" prop="goBackDate">
							<a-date-picker v-model="carform.goBackDate" allowClear style="width: 267px"
								:disabled-date="disabledDate" placeholder="回程日期" @change="changgBDate" />
						</a-form-model-item>
					</a-col>
					<a-col :span="8"></a-col>
					<a-col :span="8">
						<a-form-model-item label="预计用车时长(天)" prop="days">
							<a-input v-model="carform.days" disabled placeholder="请输入用车时长"></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="备注" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
							<a-input v-model="carform.remark" allowClear placeholder="请输入" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<div class="pay_top">
						<span class="form_title">车辆明细</span>
					</div>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="用车人" prop="carUser" :rules="{
							required: true,
							message: '请输入用车人',
							trigger: 'change',
						}">
							<a-input v-model="carform.carUser" allowClear placeholder='若预约司机,请填写"行政司机"'></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="同行人" prop="peer" :rules="{
							required: true,
							message: '请输入同行人',
							trigger: 'change',
						}">
							<a-input v-model="carform.peer" allowClear placeholder="填入同行的所有人的名字"></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="车辆属性" prop="carTypes" :rules="{
							required: true,
							message: '请选择车辆属性',
							trigger: 'change',
						}">
							<a-select v-model="carform.carTypes" allowClear placeholder="请选择">
								<a-select-option :key="index" v-for="(item, index) in carMap2" :value="index">
									{{ item }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="车牌号码" v-if="carform.carTypes == 0" prop="plateNumber" :rules="{
							required: true,
							message: '请输入车牌号码',
							trigger: 'change',
						}">
							<a-select show-search v-model="carform.plateNumber" allowClear placeholder="请选择"
								@change="changelate" @focus="listNow">
								<a-select-option :key="index" v-for="(item, index) in plateNumberList2"
									:value="item.plateNumber">
									{{ item.plateNumber }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
						<a-form-model-item label="车牌号码" v-else prop="plateNumber" :rules="{
							required: true,
							message: '请输入车牌号码',
							trigger: 'change',
						}">
							<a-input v-model="carform.plateNumber" allowClear placeholder="车牌号"></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8" v-if="carform.carTypes == 0">
						<a-form-model-item label="最新里程数" prop="latestMileage">
							<a-input v-model="carform.latestMileage" disabled allowClear placeholder="最新里程数"></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="用车事由" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }"
							prop="carReason" :rules="{
								required: true,
								message: '请输入用车事由',
								trigger: 'change',
							}">
							<a-input v-model="carform.carReason" allowClear placeholder="请列明项目编号及事由(需全部列明)"></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="出差地(具体到区)" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }"
							prop="prefecture" :rules="{
								required: true,
								message: '请输入出差地(具体到区)',
								trigger: 'change',
							}">
							<a-input v-model="carform.prefecture" allowClear placeholder="目的地、经由地(需全部列明)"></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<!-- <a-row>
					<div class="btn_last">
						<a-button type="primary" @click="add_detail"> 新增车辆明细 </a-button>
					</div>
				</a-row> -->
				<a-row>
					<div class="last_title">
						<div style="font-size: 18px">流程使用要求：</div>
						1、因公使用车辆人员必须通过【云管家-车辆管理-用车申请】申请使用车辆，申请未通过，不得使用车辆。<br />
						2、用完车辆还车后需要使用【云管家-车辆管理-还车补贴申请】填写时请关联本申请单，否则不计发补贴。<br />
						3、车辆加油时必须通过【云管家-车辆管理-还车补贴】填写加油报备。<br />
						4、出车前、出车后、加油报备时必须填写车辆里程数，并将里程表读数拍照上传，加油时必须填写加油金额，将加油发票拍照上传（用加卡加油时拍加油小票）；以上数字填写必须与照片中的读数一致<br />
						5、一车一申请，同一个申请单只能提交单辆车的用车申请
					</div>
				</a-row>
			</a-form-model>
		</a-modal>
		<a-modal title="还车补贴申请重新提交" :visible="returncarvisible" @cancel="returncarvisible = false"
			:confirm-loading="confirmLoading" width="70%" :maskClosable="false">
			<template slot="footer">
				<a-button key="submit" type="primary" :loading="loading" @click="handleOkreturnCar"> 提交 </a-button>
				<a-button key="back" @click="returncarvisible = false"> 取消 </a-button>
			</template>
			<a-form-model :model="returncarform" :rules="returncarrules" ref="hcruleForm" :label-col="labelCol4"
				:wrapper-col="wrapperCol4">
				<a-row style="margin-bottom: 15px"><span class="form_title">表单信息</span></a-row>
				<a-row>
					<a-form-model-item label="选择抄送人" :label-col="labelCol2" :wrapper-col="wrapperCol2">
						<ccChange :data="ccC" @targetKeys="getreturncardata" v-if="isRouterAlive" />
					</a-form-model-item>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="关联审批单" :rules="{
							required: true,
						}">
							<a-button type="primary" @click="showAuditCode2"> 关联 </a-button>
							<!-- <a-input allowClear v-model="form.auditCode" @click="showAuditCode" :disabled="!form.reimburseType" placeholder="请输入"></a-input> -->
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="审批单" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
							<div>
								<span v-for="(item, index) in auditCodeData" :key="index" class="auditItem">
									<span @click="handelAudit(index)">{{ item.processName }}</span>
									<a-icon class="close_icon2" @click="delete_auditCode(index)" type="close" />
								</span>
								<span v-for="(item, index) in auditCodeData2" :key="index" class="auditItem">
									<span @click="handelAudit2(index)">{{ item.title }}</span>
									<a-icon class="close_icon2" @click="delete_auditCode2(index)" type="close" />
								</span>
								<span v-for="(item, index) in auditCodeData3" :key="index" class="auditItem">
									<span @click="handelAudit3(index)">{{ item.title }}</span>
									<a-icon class="close_icon2" @click="delete_auditCode3(index)" type="close" />
								</span>
								<span v-for="(item, index) in auditCodeData4" :key="index" class="auditItem">
									<span @click="handelAudit4(index)">{{ item.title }}</span>
									<a-icon class="close_icon2" @click="delete_auditCode4(index)" type="close" />
								</span>
							</div>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="所属部门" :rules="{
							required: true,
						}">
							<a-tree-select allowClear :treeData="deptTree" @change="ccsd" placeholder="请输入"
								v-model="returncarform.belongDeptId" treeDefaultExpandAll>
							</a-tree-select>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="车辆属性" :rules="{
							required: true,
						}">
							<a-select show-search allowClear class="margin_self" @change="ccsds"
								v-model="returncarform.carTypes" placeholder="请选择">
								<a-select-option :key="index" v-for="(item, index) in carMap2" :value="index">
									{{ item }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="牌照号" :rules="{
							required: true,
						}">
							<a-select v-model="returncarform.plateNumber" @change="changePlateNum" disabled allowClear
								show-search placeholder="请选择" v-if="returncarform.carTypes == '0'">
								<a-select-option :key="index" v-for="(item, index) in plateNumberList"
									:value="item.plateNumber">
									{{ item.plateNumber }}
								</a-select-option>
							</a-select>
							<a-input v-model="returncarform.plateNumber" @input="ccsd" v-else placeholder="请输入牌照号">
							</a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<!-- <a-col :span="8">
						<a-form-model-item label="实际用车时间" prop="useCarDate">
							<a-date-picker v-model="returncarform.useCarDate" @change="useCarDateChange" show-time
								:show-time="{ format: 'HH:mm' }" format="YYYY-MM-DD HH:mm" allowClear
								style="width: 267px" placeholder="请选择" />
						</a-form-model-item>
					</a-col> -->
					<!-- <a-col :span="8">
						<a-form-model-item label="实际用车日期" prop="useCarDate">
							<a-date-picker v-model="returncarform.useCarDate" valueFormat="YYYY-MM-DD" allowClear style="width: 267px"
							 placeholder="请选择" />
						</a-form-model-item>
					</a-col> -->
					<!-- <a-col :span="8">
						<a-form-model-item label="实际还车日期" prop="stillCarDate">
							<a-date-picker v-model="returncarform.stillCarDate" valueFormat="YYYY-MM-DD" allowClear style="width: 267px"
							 placeholder="请选择" />
						</a-form-model-item>
					</a-col> -->
					<a-col :span="8">
						<a-form-model-item label="实际用车日期" prop="data" style="width: 100%;" :rules="{
							required: true,
							message: '请输入实际用车日期',
							trigger: 'change',
						}">
							<a-date-picker allowClear v-model="returncarform.data" placeholder="选择日期"
								format="YYYY-MM-DD" @change="onChangeData" />
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="实际用车时间" prop="time" style="width: 100%;" :rules="{
							required: true,
							message: '请输入实际用车时间',
							trigger: 'change',
						}">
							<a-time-picker allowClear v-model="returncarform.time" format="HH:mm" valueFormat="HH:mm"
								@change="onChangeTime" />
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="最新里程数(km)" prop="latestMileage">
							<a-input v-model="returncarform.latestMileage" disabled placeholder="请输入数字"></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="出车前里程(km)" :rules="{
							required: true,
						}">
							<a-input v-model="returncarform.goMileage" @input="changtravel" placeholder="请输入数字">
							</a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="还车时里程(km)" prop="backMileage">
							<a-input v-model="returncarform.backMileage" @input="changtravel" placeholder="请输入数字">
							</a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="行驶里程数(km)">
							<a-input disabled v-model="returncarform.travelMileage" placeholder="请输入数字"></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="申请补贴里程(km)" prop="applyMileage">
							<a-input v-model="returncarform.applyMileage" placeholder="请输入与工作相关的实际里程数"></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="目的地">
							<a-input v-model="returncarform.destination" placeholder="请输入您的目的地"></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="备注" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
							<a-textarea :auto-size="{ minRows: 1, maxRows: 3 }" v-model="returncarform.remark2"
								allowClear placeholder="请输入" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="出车前后里程" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }" :rules="{
							required: true,
						}">
							<uploadImgJavam @add="mImgadd" @reduce="mImgreduce" :data="mileageImgs"
								v-if="isRouterAlive" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="出车后车内外卫生" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }" :rules="{
							required: true,
						}">
							<uploadImgJavah @add="hImgadd" @reduce="hImgreduce" :data="hygieneImgs"
								v-if="isRouterAlive" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="车辆情况">
							<a-select show-search allowClear class="margin_self"
								v-model="returncarform.vehicleCondition" placeholder="请选择">
								<a-select-option :key="index" v-for="(item, index) in carStatus" :value="index">
									{{ item }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
					<a-col :span="16">
						<a-form-model-item label="车辆备注" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }"
							v-if="returncarform.vehicleCondition == 2">
							<a-input v-model="returncarform.remark" placeholder="请输入" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<div class="pay_top">
						<span class="form_title">加油详情</span>
					</div>
				</a-row>
				<a-row v-for="(domain, index) in returncarform.oils" :key="index">
					<a-col :span="8">
						<a-form-model-item label="加油里程(km)">
							<a-input v-model="domain.fuelMileage" placeholder="请输入"></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="加油金额(元)">
							<a-input v-model="domain.fuelMoney" @input="returncarMoney" placeholder="请输入"></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<div class="closeIoc">
							<a-icon class="delico" @click="delItemOils(index)" v-if="returncarform.oils.length > 1"
								type="close" />
						</div>
					</a-col>
				</a-row>
				<a-row>
					<div class="rowBox">
						<a-button type="primary" @click="addPush"> 增加加油详情 </a-button>
					</div>
				</a-row>

				<a-row>
					<a-col :span="8">
						<a-form-model-item label="本次出行加油金额">
							<a-input disabled v-model="returncarform.money" placeholder="请输入"></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="金额大写">
							<a-input disabled v-model="returncarform.capitalizeMoney" placeholder="请输入"></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>

				<a-row>
					<div class="last_title">
						<div style="font-size: 18px">流程使用说明：</div>
						出车前和出车后必须拍照记录当时车辆里程。如果加油，请将加油发票或小票拍照存档（办油卡的拍小票）。
					</div>
				</a-row>
			</a-form-model>
		</a-modal>
		<a-modal v-model="bankvisible" title='添加新收款账户' @ok="bankOk" width="400px" style="text-align: center;">
			<a-tabs default-active-key="1" @change="callback">
				<a-tab-pane key="1" tab="支付宝账号">
					<a-form-model :model="bankform" :label-col="labelCol2" :wrapper-col="wrapperCol2">
						<a-form-model-item label="户名">
							<a-input v-model="bankform.name" />
						</a-form-model-item>
						<a-form-model-item label="账号">
							<a-input v-model="bankform.accountNum" type="number" />
						</a-form-model-item>
					</a-form-model>
				</a-tab-pane>
				<a-tab-pane key="2" tab="个人银行卡">
					<a-form-model :model="bankform" :label-col="labelCol2" :wrapper-col="wrapperCol2">
						<a-form-model-item label="户名">
							<a-input v-model="bankform.name" />
						</a-form-model-item>
						<a-form-model-item label="卡号">
							<a-input v-model="bankform.accountNum" type="number" />
						</a-form-model-item>
						<a-form-model-item label="银行">
							<a-input v-model="bankform.bank" />
						</a-form-model-item>
					</a-form-model>
				</a-tab-pane>
			</a-tabs>
		</a-modal>
		<!-- 付款申请补充文件 -->
		<a-modal v-model='addFilevisit' title='补充文件' @ok="addFilevisit = false" width="40%"
			@cancel="addFilevisit = false">
			<a-row>
				<a-col :span="12">
					<a-form-model-item label="图片" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
						<uploadImgApply :data="imgDataApply" v-if="addFilevisit"></uploadImgApply>
						<!-- <uploadImgJavaAdd :data="uploadDataapply" v-if="addFilevisit" /> -->
					</a-form-model-item>
				</a-col>
				<a-col :span="12">
					<a-form-model-item label="附件" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
						<uploadFileApply :data="fileDataApply" v-if="addFilevisit"></uploadFileApply>
						<!-- <uploadFileCodeAdd :data="" v-if="addFilevisit" /> -->
					</a-form-model-item>
				</a-col>
			</a-row>

		</a-modal>
		<a-modal v-model='addDocuvisit' title='补充文件' @ok="addImages" width="40%">
			<a-row>
				<a-col :span="12" v-if="uploadDataImgAdd.type">
					<a-form-model-item label="图片" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
						<uploadImgJavaAdd :data="uploadDataImgAdd" v-if="isRouterAlive" />
					</a-form-model-item>
				</a-col>
				<a-col :span="12" v-if="uploadDataAdd.type">
					<a-form-model-item label="附件" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
						<uploadFileCodeAdd :data="uploadDataAdd" v-if="isRouterAlive" />
					</a-form-model-item>
				</a-col>
			</a-row>
			<a-row>
				<a-col :span="24" v-if="uploadDataImgAddm.type">
					<a-form-model-item label="出车前后里程" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
						<uploadImgJavaAdd :data="uploadDataImgAddm" v-if="isRouterAlive" />
					</a-form-model-item>
				</a-col>
			</a-row>
			<a-row>
				<a-col :span="24" v-if="uploadDataImgAddh.type">
					<a-form-model-item label="出车后车内外卫生" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
						<uploadImgJavaAdd :data="uploadDataImgAddh" v-if="isRouterAlive" />
					</a-form-model-item>
				</a-col>
			</a-row>
			<!-- <a-row>
				<a-col :span="24" v-if="uploadDataImgAddn.type">
					<a-form-model-item label="导航路线截图" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
						<uploadImgJavaAdd :data="uploadDataImgAddn" v-if="isRouterAlive" />
					</a-form-model-item>
				</a-col>
			</a-row> -->
		</a-modal>
		<a-modal v-model="addApplyvisit" title="请选择申请类型" @ok="addApplyvisit = false" width="50%">
			<div class="setback">
				<div class="item" @click="currency">
					<img src="../../assets/image/tongyong.svg" />
					<div class="size">
						通用申请
					</div>
				</div>
				<!-- <div class="item" @click="currencySalary">
					<img src="../../assets/image/tongyong.svg" />
					<div class="size">
						项目金额调整
					</div>
				</div> -->
				<div class="item">
					<img src="../../assets/image/qingjia2.svg" />
					<div class="size">
						请假申请
					</div>
				</div>
				<div class="item">
					<img src="../../assets/image/zhuanzheng2.svg" />
					<div class="size">
						转正申请
					</div>
				</div>
				<div class="item" @click="seal">
					<img src="../../assets/image/yongyin.svg" />
					<div class="size">
						用印申请
					</div>
				</div>
				<div class="item">
					<img src="../../assets/image/diaogang2.svg" />
					<div class="size">
						调岗申请
					</div>
				</div>
				<div class="item">
					<img src="../../assets/image/lizhi2.svg" />
					<div class="size">
						离职申请
					</div>
				</div>
				<div class="item" @click="salary">
					<img src="../../assets/image/xinzi.svg" />
					<div class="size">
						录用审批
					</div>
				</div>
				<div class="item" @click="adjustment">
					<img src="../../assets/image/tiaoxin.svg" />
					<div class="size">
						调薪申请
					</div>
				</div>
				<div class="item" @click="feedback">
					<img src="../../assets/image/tongyong.svg" />
					<div class="size">
						需求反馈
					</div>
				</div>
				<div class="item" @click="tenderEvent" v-if="tenderLimitation">
					<img src="../../assets/image/tenderBlue.png" />
					<div class="size">
						投标申请
					</div>
				</div>
			</div>
		</a-modal>
		<a-modal v-model="adjustmentvisit" title="调薪申请" @ok="adjustmentOk" width="80%">
			<template slot="footer">
				<a-button key="submit" type="primary" @click="adjustmentOk"> 提交 </a-button>
				<a-button key="back" @click="adjustmentvisit = false"> 取消 </a-button>
			</template>
			<a-form-model :model="adjustmentform" ref="txruleForm" :rules="rules" :label-col="labelCol4"
				:wrapper-col="wrapperCol4">
				<a-row style="margin-bottom: 15px"><span class="form_title">表单信息</span></a-row>
				<a-row>
					<a-form-model-item label="选择抄送人" :label-col="labelCol2" :wrapper-col="wrapperCol2">
						<ccChange :data="ccC" @targetKeys="adjustmentgetdata" v-if="isRouterAlive" />
					</a-form-model-item>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="所属部门" prop="userDept" :rules="{
							required: true,
							message: '请选择所属部门',
							trigger: 'change',
						}">
							<a-tree-select allowClear :treeData="deptTree2" placeholder="请输入"
								v-model="adjustmentform.userDept" treeDefaultExpandAll @change="leaderid($event)">
							</a-tree-select>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="姓名" prop="userId" :rules="{
							required: true,
							message: '请选择姓名',
							trigger: 'change',
						}">
							<a-select allowClear placeholder="请选择" v-model="adjustmentform.userId"
								:disabled="!adjustmentform.userDept">
								<a-select-option :value="item.userId" v-for="(item, index) in plainOptions"
									:key="index">
									{{ item.userName }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="工号" prop="jobNumber" :rules="{
							required: true,
							message: '请输入工号',
							trigger: 'change',
						}">
							<a-input v-model="adjustmentform.jobNumber" placeholder="请输入"></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="岗位名称" prop="post" :rules="{
							required: true,
							message: '请输入岗位名称',
							trigger: 'change',
						}">
							<a-input v-model="adjustmentform.post" placeholder="请输入"></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="原薪资(元)" prop="originalSalary" :rules="{
							required: true,
							message: '请输入原薪资',
							trigger: 'change',
						}">
							<a-input @input="changeoriginalCapital" type="number"
								v-model="adjustmentform.originalSalary" placeholder="请输入"></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="原薪资大写(元)" prop="originalCapital" :rules="{
							required: true,
							message: '请输入原薪资大写',
							trigger: 'change',
						}">
							<a-input disabled v-model="adjustmentform.originalCapital" placeholder="请输入"></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="调整后薪资(元)" prop="adjustedSalary" :rules="{
							required: true,
							message: '请输入调整后薪资',
							trigger: 'change',
						}">
							<a-input @input="changeadjustedCapital" type="number"
								v-model="adjustmentform.adjustedSalary" placeholder="请输入"></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="调整后薪资大写(元)" prop="adjustedCapital" :rules="{
							required: true,
							message: '请输入调整后薪资大写',
							trigger: 'change',
						}">
							<a-input disabled v-model="adjustmentform.adjustedCapital" placeholder="请输入"></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="调整月份" prop="adjustedMonth" :rules="{
							required: true,
							message: '请选择调整月份',
							trigger: 'change',
						}">
							<a-select allowClear placeholder="请选择" v-model="adjustmentform.adjustedMonth">
								<a-select-option :value="item" v-for="(item, index) in month" :key="index">
									{{ item }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="调薪原因" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }"
							prop="reason" :rules="{
								required: true,
								message: '请输入调薪原因',
								trigger: 'change',
							}">
							<a-textarea :auto-size="{ minRows: 3, maxRows: 3 }" v-model="adjustmentform.reason"
								placeholder="请输入" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="附件">
							<uploadFileCode :data="uploadData" v-if="isRouterAlive" />
						</a-form-model-item>
					</a-col>
				</a-row>
			</a-form-model>
		</a-modal>
		<a-modal v-model="salaryvisit" title="录用审批" @ok="salaryOk" width="60%">
			<template slot="footer">
				<a-button key="submit" type="primary" @click="salaryOk"> 提交 </a-button>
				<a-button key="back" @click="salaryvisit = false"> 取消 </a-button>
			</template>
			<a-form-model :model="salaryform" ref="xzruleForm" :rules="rules" :label-col="labelCol4"
				:wrapper-col="wrapperCol4">
				<a-row style="margin-bottom: 15px"><span class="form_title">表单信息</span></a-row>
				<a-row>
					<a-form-model-item label="选择抄送人" :label-col="labelCol2" :wrapper-col="wrapperCol2">
						<ccChange :data="ccC" @targetKeys="salarygetdata" v-if="isRouterAlive" />
					</a-form-model-item>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="所属部门" prop="userDept" :rules="{
							required: true,
							message: '请选择所属部门',
							trigger: 'change',
						}">
							<a-tree-select allowClear :treeData="deptTree2" placeholder="请输入"
								v-model="salaryform.userDept" treeDefaultExpandAll @change="leaderid($event)">
							</a-tree-select>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="姓名" prop="userId" :rules="{
							required: true,
							message: '请选择姓名',
							trigger: 'change',
						}">
							<a-select allowClear placeholder="请选择" v-model="salaryform.userId"
								:disabled="!salaryform.userDept">
								<a-select-option :value="item.userId" v-for="(item, index) in plainOptions"
									:key="index">
									{{ item.userName }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="岗位" prop="post" :rules="{
							required: true,
							message: '请输入岗位',
							trigger: 'change',
						}">
							<a-input v-model="salaryform.post" placeholder="如业务人员"></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="学历" prop="education" :rules="{
							required: true,
							message: '请输入学历',
							trigger: 'change',
						}">
							<a-input v-model="salaryform.education" placeholder="如全日制本科"></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="学校" prop="school" :rules="{
							required: true,
							message: '请输入学校',
							trigger: 'change',
						}">
							<a-input v-model="salaryform.school" placeholder="如浙江大学"></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="入职日期" prop="onboardingDate" :rules="{
							required: true,
							message: '请选择入职日期',
							trigger: 'change',
						}">
							<a-date-picker valueFormat="YYYY-MM-DD" style="width: 227px"
								v-model="salaryform.onboardingDate" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="试用期薪资(元)" prop="probationSalary" :rules="{
							required: true,
							message: '请输入试用期薪资',
							trigger: 'change',
						}">
							<a-input v-model="salaryform.probationSalary" type="number" placeholder="请输入"></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="转正薪资(元)" prop="positiveSalary" :rules="{
							required: true,
							message: '请输入转正薪资',
							trigger: 'change',
						}">
							<a-input v-model="salaryform.positiveSalary" type="number" placeholder="请输入"></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }" label="备注" prop="remark"
							:rules="{
								required: true,
								message: '请输入备注',
								trigger: 'change',
							}">
							<a-textarea :auto-size="{ minRows: 3, maxRows: 3 }" v-model="salaryform.remark"
								placeholder="请输入" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="图片" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
							<uploadImgJava :data="uploadDataImg" v-if="isRouterAlive" />
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="附件" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
							<uploadFileCode :data="uploadData" v-if="isRouterAlive" />
						</a-form-model-item>
					</a-col>
				</a-row>
			</a-form-model>
		</a-modal>
		<a-modal v-model="currencyvisit" title="通用审批" @ok="currencyOk" width="60%">
			<template slot="footer">
				<a-button key="submit" type="primary" @click="currencyOk"> 提交 </a-button>
				<a-button key="back" @click="currencyvisit = false"> 取消 </a-button>
			</template>
			<a-form-model :model="currencyform" ref="tyruleForm" :rules="rules" :label-col="labelCol2"
				:wrapper-col="wrapperCol2">
				<a-row><span class="form_title2">表单信息</span></a-row>
				<a-row>
					<a-form-model-item label="选择抄送人" :label-col="labelCol2" :wrapper-col="wrapperCol2">
						<ccChange :data="ccC" @targetKeys="currencygetdata" v-if="isRouterAlive" />
					</a-form-model-item>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="申请内容" prop="content" :rules="{
							required: true,
							message: '请输入申请内容',
							trigger: 'change',
						}">
							<a-textarea :auto-size="{ minRows: 5, maxRows: 10 }" v-model="currencyform.content"
								placeholder="请输入"></a-textarea>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="审批详情" prop="detail" :rules="{
							required: true,
							message: '请输入审批详情',
							trigger: 'change',
						}">
							<a-textarea :auto-size="{ minRows: 5, maxRows: 10 }" v-model="currencyform.detail"
								placeholder="请输入"></a-textarea>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="图片" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
							<uploadImgJava :data="uploadDataImg" v-if="isRouterAlive" />
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="附件" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
							<uploadFileCode :data="uploadData" v-if="isRouterAlive" />
						</a-form-model-item>
					</a-col>
				</a-row>
			</a-form-model>
		</a-modal>
		<a-modal v-model="sealvisit" title="用印审批" @ok="sealOk" width="60%">
			<template slot="footer">
				<a-button key="submit" type="primary" @click="sealOk"> 提交 </a-button>
				<a-button key="back" @click="sealvisit = false"> 取消 </a-button>
			</template>
			<a-form-model :model="sealform" ref="yyruleForm" :rules="rules" :label-col="labelCol3"
				:wrapper-col="wrapperCol3">
				<a-row><span class="form_title2">表单信息</span></a-row>
				<a-row>
					<a-form-model-item label="选择抄送人" :label-col="labelCol2" :wrapper-col="wrapperCol2">
						<ccChange :data="ccC" @targetKeys="sealgetdata" :carbon="carbon" v-if="isRouterAlive" />
					</a-form-model-item>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="用印部门" prop="userDept" :rules="{
							required: true,
							message: '请选择用印部门',
							trigger: 'change',
						}">
							<!-- <a-select allowClear placeholder="用印部门" v-model="sealform.userDept" @change="leaderid($event)">
								<a-select-option :value="item.dept_id" v-for="(item, index) in deptlist" :key="index">
									{{ item.dept_name }}
								</a-select-option>
							</a-select> -->
							<a-tree-select allowClear :treeData="deptTree2" placeholder="用印部门"
								v-model="sealform.userDept" @change="leaderid($event)" treeDefaultExpandAll>
							</a-tree-select>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="用印人" prop="sealUser" :rules="{
							required: true,
							message: '请选择用印人',
							trigger: 'change',
						}">
							<a-select allowClear placeholder="用印人" v-model="sealform.sealUser"
								:disabled="!sealform.userDept">
								<a-select-option :value="item.userId" v-for="(item, index) in plainOptions"
									:key="index">
									{{ item.userName }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="日期" prop="stampDate" :rules="{
							required: true,
							message: '请选择日期',
							trigger: 'change',
						}">
							<a-date-picker valueFormat="YYYY-MM-DD" style="width: 241px" :value="sealform.stampDate"
								@change="stampDateChange" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="用印文件名称" prop="document" :rules="{
							required: true,
							message: '请输入用印文件名称',
							trigger: 'change',
						}">
							<a-input v-model="sealform.document" placeholder="请输入"></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="文件份数" prop="documentNum" :rules="{
							required: true,
							message: '请输入文件份数',
							trigger: 'change',
						}">

							<a-input v-model="sealform.documentNum" placeholder="请输入"
								oninput="value=value.replace(/[^\d]/g,'')"></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="文件类别" prop="documentType" :rules="{
							required: true,
							message: '请选择文件类别',
							trigger: 'change',
						}">
							<a-select allowClear placeholder="文件类别" v-model="sealform.documentType">
								<a-select-option :value="item.dictValue" v-for="(item, index) in sealtype" :key="index">
									{{ item.dictLabel }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="加盖何种印章" prop="sealType" :rules="{
							required: true,
							message: '请选择加盖何种印章',
							trigger: 'change',
						}">
							<a-select allowClear placeholder="加盖何种印章" v-model="sealform.sealType"
								@change="choseSealType">
								<a-select-option :value="item.dictValue" v-for="(item, index) in sealdocument"
									:key="index">
									{{ item.dictLabel }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="备注">
							<a-input v-model="sealform.remark" placeholder="请输入"></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="图片" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
							<uploadImgJava :data="uploadDataImg" v-if="isRouterAlive" />
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="附件" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" :rules="{
							required: true
						}">
							<uploadFileCodeImport @add="addNumber" @reduce="reduceNumber" :data="uploadData"
								v-if="isRouterAlive" />
						</a-form-model-item>
					</a-col>
				</a-row>
			</a-form-model>
		</a-modal>
		<selectAuditCode @getIdData="getIdData" :kind="kind" :approvalId="approvalId" ref="selectAuditCode"
			:data="{ auditCodeData, auditCodeData2, auditCodeData3, auditCodeData4 }" @applyData='getAppCode'
			@applyData2='getAppCode2' @applyData3='getAppCode3' @applyData4='getAppCode4' v-if="isRouterAlive" />
		<selectAuditCode2 ref="selectAuditCode2"
			:data="{ auditCodeData, auditCodeData2, auditCodeData3, auditCodeData4 }" @applyData="getAppCode"
			@applyData2="getAppCode2" @applyData3="getAppCode3" @applyData4='getAppCode4' @applyAll="getApplyAll"
			v-if="isRouterAlive" />
		<service-fee-application ref="servicefeeapplication" @ok='handleOk' />
		<other-application ref="otherapplication" @ok='handleOk' />
		<feedback-application ref="feedbackapplication" @ok='handleOk' />
		<consumables-application ref="consumablesapplication" @ok='handleOk' />
		<tenderApply ref="tenderApply" @ok='handleOk' />
		<newPaymentModel ref="newPaymentModel"></newPaymentModel>
		<reApply ref="reApply"></reApply>
		<salary ref="salary" @refreshList="refreshList"></salary>
		<salaryEditModal ref="salaryEditModal" :audit="false"></salaryEditModal>
        <quotation ref="quotation" :audit="false"></quotation>
        <contractReview ref="contractReview" :audit="false"></contractReview>
        <tender ref="tender" :audit="false"></tender>
		<contractDetail ref="contractDetail" :audit="false"></contractDetail>
        <terminationModal ref="terminationModal"  :audit="false"></terminationModal>

	</div>
</template>

<script>
import {salaryDetail} from '@/api/budget'
import salaryEditModal from './modules/salaryEditModal.vue'
import salary from './modules/salary'
import newPaymentModel from './modules/newPaymentModel.vue'
import { tree_all } from '@/api/purchase'
import {
	getDeptListEnable,
	getDeptListEnable2
} from '@/api/system'
import debounce from 'lodash/debounce'
import {
	get_dict,
	returnDept2,
	get_users2,
} from '@/utils/unit_axios'
import {
	audit_list,
	contract_apply_get,
	contract_apply_save,
	contract_apply_code,
	apply_code,
	reimburse_apply_save,
	payment_apply_get,
	seal_apply_code,
	seal_apply_save,
	seal_apply_get,
	universal_apply_code,
	universal_apply_save,
	universal_apply_get,
	payment_apply_code,
	payment_apply_save,
	list_code,
	apply_save,
	goods_rejected_info,
	review_apply_code,
	review_apply_save,
	salary_approval_code,
	salary_approval_save,
	salary_adjustment_code,
	salary_adjustment_save,
	salary_approval_get,
	salary_adjustment_get,
	feedback_get
} from '@/api/financial'
import {
	STable
} from '@/components'
import {
	biz_car_apply_save,
	biz_car_apply_code,
	listAllPage,
	biz_car_subsidy_apply_code,
	biz_car_subsidy_apply_save,
	biz_car_registration_list
} from '@/api/administrative'
import {
	getBusinessListMy,
	delProcessIns,
	delBusiness,
	modalMap,
	resultMap,
	getPurchaseByBusiness,
	getReimburseApply,
	get_accounts_receivable,
	accounts_receivable_delete,
	accounts_receivable_save,
	getReviewApply,
	getBusinessFeeApply,
	getClaimByBusiness,
	getScrapByBusiness,
	getCarApply,
	returnCarApply,
	getCoverApply,
	getOtherApply
} from '@/api/activiti'
import {
	get_dept_tree,
	dict,
	get_dept_tree2,
	claim_apply,
	goods_rejected_code,
	goods_rejected_save,
	scrapped_apply,
	// assetget_list2,
	daily_list,
	consumables_get
} from '@/api/assetmenag'
import uploadFileCode from '@/components/module/uploadFileCode.vue'
import uploadFileCodeImport from '@/components/module/uploadFileCodeImport.vue'
import uploadImgJava from '@/components/module/uploadImgJava.vue'
import uploadFileCodeAdd from '@/components/module/uploadFileCodeAdd.vue'
import uploadImgJavaAdd from '@/components/module/uploadImgJavaAdd.vue'
import BusinessModal from './modules/BusinessModal.vue'
import LeaveModal from './modules/LeaveModal.vue'
import PurchaseModal from './modules/PurchaseModal.vue'
import ScrapModal from './modules/ScrapModal.vue'
import receiveModal from './modules/receiveModal.vue'
import ProcFlowModal from './modules/ProcFlowModal.vue' //历史
import OperationModal from './modules/OperationModal.vue'
import ServiceModal from './modules/ServiceModal.vue'
import ReimbursementModal from './modules/ReimbursementModal.vue'
import payMentModal from '@/views/activiti/modules/payMentModal.vue'
import contractModal from '@/views/activiti/modules/contractModal.vue'
import sealModal from '@/views/activiti/modules/sealModal.vue'
import currencyModal from '@/views/activiti/modules/currencyModal.vue'
import returnModal from '@/views/activiti/modules/returnModal.vue'
import ccChange from '@/components/module/ccChange'
import selectAuditCode from '@/components/module/selectAuditCode.vue'
import selectUnitPay from '@/components/module/selectUnitPay.vue'
import carModal from '@/views/activiti/modules/carModal.vue'
import returncarModal from '@/views/activiti/modules/returncarModal.vue'
import salaryModal from '@/views/activiti/modules/salaryModal.vue'
import adjustmentModal from '@/views/activiti/modules/adjustmentModal.vue'
import chargeModal from '@/views/activiti/modules/chargeModal.vue'
import otherModal from '../activiti/modules/otherModal.vue'
import feedbackModal from '../activiti/modules/feedbackModal.vue'
import InventoryModal from '@/views/activiti/modules/InventoryModal.vue'

import uploadImgJavam from '@/components/module/uploadImgJavam.vue'
import uploadImgJavah from '@/components/module/uploadImgJavah.vue'
import uploadImgJavan from '@/components/module/uploadImgJavan.vue'
import selectAuditCode2 from '@/components/module/selectAuditCode2.vue'

import ServiceFeeApplication from '@/components/module/ServiceFeeApplication'
import OtherApplication from '@/components/module/OtherApplication'
import FeedbackApplication from '@/components/module/FeedbackApplication'
import ConsumablesApplication from '@/components/module/ConsumablesApplication'
import uploadImgApply from '@/components/module/uploadImgApply.vue'
import uploadFileApply from '@/components/module/uploadFileApply.vue'
import reApply from '@/views/finance/components/reApply.vue'
import quotation from './modules/quotation.vue'
import contractReview from '@/views/activiti/modules/contractReview.vue'
import tenderApply from '@/views/activiti/tenderApply.vue'
import tender from '@/views/activiti/modules/tender.vue'
import contractDetail from '@/views/projectCollection/contract/contractDetail.vue'
import terminationModal from '@/views/activiti/modules/terminationModal.vue'



import {
	checkPermission
} from '@/utils/permissions'
const deptMap = {}
const columns2 = [{
	title: '资产类别',
	dataIndex: 'asset_type',
	key: 'asset_type',
	scopedSlots: {
		customRender: 'asset_type',
	},
	ellipsis: true,
},
{
	title: '物品名称',
	dataIndex: 'name',
	key: 'name',
	ellipsis: true,
},
{
	title: '物品编号',
	dataIndex: 'asset_sn',
	key: 'asset_sn',
	ellipsis: true,
},
{
	title: '规格型号',
	dataIndex: 'model',
	key: 'model',
	ellipsis: true,
},
{
	title: '物品状态',
	dataIndex: 'state',
	key: 'state',
	scopedSlots: {
		customRender: 'state',
	},
	ellipsis: true,
},
{
	title: '采购时间',
	dataIndex: 'purchase_time',
	key: 'purchase_time',
	ellipsis: true,
},
{
	title: '采购价格',
	dataIndex: 'purchase_price',
	key: 'purchase_price',
	ellipsis: true,
},
{
	title: '当前估值',
	dataIndex: 'value',
	key: 'value',
	ellipsis: true,
},
{
	title: '责任人',
	dataIndex: 'charger',
	key: 'charger',
	ellipsis: true,
},
{
	title: '责任部门',
	dataIndex: 'dept_id',
	key: 'dept_id',
	scopedSlots: {
		customRender: 'dept_id',
	},
	ellipsis: true,
},
]

export default {
	record: '',
	name: 'TableList',
	components: {
		VNodes: {
			functional: true,
			render: (h, ctx) => ctx.props.vnodes,
		},
		tenderApply,
		tender,
		quotation,
		salaryEditModal,
		salary,
		reApply,
		uploadFileApply,
		uploadImgApply,
		uploadFileCodeAdd,
		uploadImgJavaAdd,
		ProcFlowModal,
		STable,
		BusinessModal,
		LeaveModal,
		PurchaseModal,
		ScrapModal,
		receiveModal,
		OperationModal,
		ServiceModal,
		ReimbursementModal,
		payMentModal,
		contractModal,
		ccChange,
		uploadFileCode,
		uploadImgJava,
		selectAuditCode,
		sealModal,
		currencyModal,
		returnModal,
		selectUnitPay,
		carModal,
		returncarModal,
		salaryModal,
		adjustmentModal,
		chargeModal,
		otherModal,
		feedbackModal,
		InventoryModal,

		uploadImgJavam,
		uploadImgJavah,
		uploadImgJavan,
		uploadFileCodeImport,
		selectAuditCode2,

		ServiceFeeApplication,
		OtherApplication,
		FeedbackApplication,
		ConsumablesApplication,
		newPaymentModel,
		contractReview,
		contractDetail,
		terminationModal
	},
	data() {
		return {
			recordNumber: 0,
			typeIndex: undefined,
			arrApply: [],
			arrPurshe: [],
			arrApply2: [],
			arrPurshe2: [],
			arrApply3: [],
			arrPurshe3: [],
			arrApply4: [],
			arrPurshe4: [],
			idList: [],
			kind: undefined,
			carbon: '',
			//防抖
			answer: "",
			timeout: null,
			mImg: 0,
			hImg: 0,
			nImg: 0,
			pushImages: false,
			scrapPara: {
				asset_sn: '',
				name: '',
			},
			columns2,
			deptMap,
			number: 0,
			carform: {},
			returncarform: {},
			returncarvisible: false,
			returncarrules: {
				relationCode: [{
					required: true,
					message: '请选择关联审批单',
					trigger: 'change',
				},],
				belongDeptId: [{
					required: true,
					message: '请选择所属部门',
					trigger: 'change',
				},],
				carTypes: [{
					required: true,
					message: '请选择车辆属性',
					trigger: 'change',
				},],
				plateNumber: [{
					required: true,
					message: '请输入牌照号',
					trigger: 'change',
				},],
				useCarDate: [{
					required: true,
					message: '请选择实际用车日期',
					trigger: 'change',
				},],
				stillCarDate: [{
					required: true,
					message: '请选择实际还车日期',
					trigger: 'change',
				},],
				goMileage: [{
					required: true,
					message: '请输入出车前里程(km)',
					trigger: 'change',
				},],
				backMileage: [{
					required: true,
					message: '请输入还车时里程(km)',
					trigger: 'change',
				},],
				applyMileage: [{
					required: true,
					message: '请输入申请补贴里程(km)',
					trigger: 'change',
				},],
				fuelMileage: [{
					required: true,
					message: '请输入加油里程(km)',
					trigger: 'change',
				},],
				fuelMoney: [{
					required: true,
					message: '请输入加油金额',
					trigger: 'change',
				},],
			},
			carrules: {
				companyUseId: [{
					required: true,
					message: '请选择申请部门',
					trigger: 'change',
				},],
				isDriver: [{
					required: true,
					message: '请选择司机预约',
					trigger: 'change',
				},],
				goToDate: [{
					required: true,
					message: '请选择预计出行日期',
					trigger: 'change',
				},],
				goBackDate: [{
					required: true,
					message: '请选择预计回程日期',
					trigger: 'change',
				},],
				days: [{
					required: true,
					message: '请输入预计用车时长（天）',
					trigger: 'change',
				},],
			},
			scrap_visit: false,
			service_visit: false,
			return_visible: false,
			moneY: '',
			is_apply_show: false,
			deptlist2: [],
			companylist2: [],
			auditCodeData: [],
			auditCodeData2: [],
			auditCodeData3: [],
			auditCodeData4: [],
			typesnum: 1,
			bankform: {
				name: '',
				accountNum: '',
				bank: '',
			},
			bankvisible: false,
			operation_visible: false,
			carvisible: false,
			bankshow: true,
			Select: {},
			banklist: [],
			scroll_y: 150,
			options: [], //部门
			followers: [], //跟进人列表
			visible: false,
			is_show_apply: false,
			payment_visible: false,
			reimburse_visible: false,
			Approvallist: [],
			companyList1: [],
			approvalId: undefined,
			details: null,
			deptlist: [],
			labelCol2: {
				span: 2
			},
			wrapperCol2: {
				span: 22
			},
			labelCol3: {
				span: 8
			},
			wrapperCol3: {
				span: 16
			},
			companylist: [],
			hasSelectedAssert: false,
			operTypeMap: {},
			isRouterAlive: true,
			imgDataApply: {
				type: 'payment-certificate',
				parent: '',
			},
			fileDataApply: {
				type: 'payment-appendix',
				code: '',
			},
			uploadData: {
				code: '',
				type: '',
			},
			uploadDataImg: {
				code: '',
				type: '',
			},
			uploadDataAdd: {
				type: '',
				parent: '',
			},
			uploadDataImgAdd: {
				type: '',
				parent: '',
			},
			uploadDataImgAddm: {
				type: '',
				parent: '',
			},
			uploadDataImgAddh: {
				type: '',
				parent: '',
			},
			uploadDataImgAddn: {
				type: '',
				parent: '',
			},
			selectedRowKeys2: [],
			description: '处理中的业务无法被删除',
			labelCol: {
				xs: {
					span: 24,
				},
				sm: {
					span: 5,
				},
			},
			wrapperCol: {
				xs: {
					span: 24,
				},
				sm: {
					span: 16,
				},
			},
			labelCol4: {
				span: 9,
			},
			wrapperCol4: {
				span: 15,
			},
			plainOptions: [],
			form: this.$form.createForm(this),
			mdl: {},
			// 高级搜索 展开/关闭
			advanced: false,
			// 查询参数
			queryParam: {},
			plateNumberList2: [],
			// 表头applyCode
			columns: [
				{
					title: '序号',
					scopedSlots: {
						customRender: 'serial',
					},
					width: 60,
				},
				{
					title: '审批编号',
					dataIndex: 'applyCode',
					ellipsis: true,
					width: 240,
				},
				{
					title: '申请标题',
					dataIndex: 'title',
					ellipsis: true,
					width: 150,
				},
				{
					title: '申请时间',
					dataIndex: 'applyTime',
					sorter: true,
					ellipsis: true,
					width: 150,
				},
				{
					title: '当前审批人',
					dataIndex: 'auditors',
					ellipsis: true,
				},
				{
					title: '当前审批环节',
					dataIndex: 'currentTask',
					ellipsis: true,
				},
				{
					title: '所属流程',
					dataIndex: 'procName',
					ellipsis: true,
				},
				{
					title: '审批意见',
					dataIndex: 'comment',
					ellipsis: true,
				},
				{
					title: '审批结果',
					dataIndex: 'result',
					scopedSlots: {
						customRender: 'result',
					},
					width: 120,
				},
				{
					title: '状态',
					dataIndex: 'status',
					scopedSlots: {
						customRender: 'status',
					},
					width: 120,
				},
				{
					title: '最后审批人',
					dataIndex: 'lastAuditor',
					ellipsis: true,
					width: 120,
				},
				{
					title: '最后审批时间',
					dataIndex: 'lastAuditorTime',
					ellipsis: true,
				},
				{
					title: '操作',
					width: '350px',
					dataIndex: 'action',
					scopedSlots: {
						customRender: 'action',
					},
				},
			],
			currencyform: {
				cc: [],
				applyCode: '',
				content: '',
				detail: '',
			},
			salaryform: {},
			adjustmentform: {},
			mileageImgs: {
				code: '',
				type: 'mileage-imgs',
			},
			hygieneImgs: {
				code: '',
				type: 'hygiene-imgs',
			},
			navigationImgs: {
				code: '',
				type: 'navigation-imgs',
			},
			operationform: {
				cc: [],
				applyCode: '',
				companyId: undefined,
				applyDeptId: undefined,
				applyUser: undefined,
				projectCode: '',
				projectName: '',
				projectPrice: '',
				paymentObject: '',
				remark: '',
			},
			sealtype: [],
			sealdocument: [],
			reimburseform: {
				cc: [],
				reimbursementCode: '',
				reimburseType: undefined,
				associateApply: [],
				reimburseMoneyTotal: '',
				remark: '',
				remarkSpec: '',
				name: '',
				accountNum: '',
				bank: '',
				reimburseDetails: [{
					expenseTime: '',
					types: undefined,
					money: '',
					remark: ''
				}],
			},
			info: {
				cc: [], //抄送人
				expectDate: '',
				ascriptionDept: undefined,
				itemType: undefined,
				remark: '',
				bizGoodsInfos: [{
					expectDate: '',
					itemType: '',
					name: '', //物品名称
					model: '', //规格型号
					amount: '', //数量
					unit: '', //单位
					remark: '', //备注
					usages: undefined, //采购物品实际使用
				},],
			},
			sealform: {
				cc: [],
				applyCode: '',
				userDept: undefined,
				sealUser: undefined,
				stampDate: '',
				document: '',
				documentNum: '',
				documentType: undefined,
				sealType: undefined,
				remark: '',
			},
			paymentform: {
				cc: [],
				companyId: undefined,
				subjectionDeptId: undefined, //:'',//隶属公司部门
				associateApply: [], //:'',//	付款申请编号
				paymentType: undefined, //:'',//	关联审批单
				auditCode: '', //:'',//	审批单号
				provinceName: '',
				cityName: '',
				cc: '', //:'',//	抄送人
				ccDeptId: '',
				ccIds: [],
				invoice: '',
				projectType: undefined, //:'',//	款项类目
				projectName: '', //:'',//项目名称
				projectMoney: '', //:'',//	付款总金额
				projectCode: '', //:'',//项目编号
				paidCount: '', //:'',//	已付金额
				payCount: '', //	本次付款总金额
				accountType: '', //	账户类型
				name: '', //	支付对象(户名)
				accountNum: '', //	支付对象(账号)
				bank: '', //	支付对象(开户行)
				province: '', //	支行地址（省）
				city: '', //	支行地址（市）
				branchBank: '', //	银行支行
				remarkSpec: '', //	特殊备注
				remark: '', //	备注
				paymentDetails: [{
					invoice: '',
					thisPayment: '', //本次支付金额
					remark: '', //	费用明细
				},],
			},
			serviceform: {
				cc: [],
				reviewCode: '',
				deptId: undefined,
				companyId: undefined,
				types: undefined,
				paymentDetails: '',
				paymentMode: undefined,
				paymentDate: '',
				paymentObject: '',
				bankOfDeposit: '',
				bankAccount: '',
				amountTotal: '',
				remark: '',
				bizReviewInfos: [{}]
			},
			receiveform: {
				cc: [],
				reason: '',
				remark: '',
				old_goods: [],
				goods: [],
			},
			returnform: {
				cc: [],
				returnReason: '',
				old_goods: [],
				applyCode: '',
				purchaseCode: '',
			},
			scrapform: {
				cc: [], //抄送人
				title: '',
				assertId: '',
				remark: '',
				scrappedPrice: '',
				dealMethod: '',
				realPrice: '',
				rcvMethod: undefined,
			},
			scrapRules: {
					remark: [{
						required: true,
						message: '请输入报废原因',
						trigger: 'blur',
					}, ],
					scrappedPrice: [{
						required: true,
						message: '请输入报废残值价格',
						trigger: 'blur',
					}, ],
					dealMethod: [{
						required: true,
						message: '请输入报废处理方式',
						trigger: 'blur',
					}, ],
					realPrice: [{
						required: true,
						message: '请输入实际处理价格',
						trigger: 'blur',
					}, ],
				},
			form: {
				// cc: '', //	抄送人
				// ccIds: [],
				// ccDeptId: '', //抄送人部门id
				cc: [],
				applyCode: '', //审批编号
				contractCode: '', //	合同编号
				contractName: '', //	合同名称
				customerName: '', //	客户名称
				contractDate: '', //	合同日期
				projectName: '', //	项目名称
				projectCode: '', //项目编号
				expiryDate: '', //	到期日期
				contractAmount: '', //	合同金额;元）
				customerContact: '', //客户联系人
				contactInformation: '', //	联系方式
				follower: undefined, //	跟进人
				followerDept: '', //	跟进人部门
			},
			// 加载数据方法 必须为 Promise 对象
			loadData: (parameter) => {
				return getBusinessListMy(Object.assign(parameter, this.queryParam))
			},
			selectedRowKeys: [],
			selectedRows: [],
			resultMap,
			statusMap: '',
			pagination2: {
				current: 1,
				pageSize: 5,
				total: 0,
			},
			deptTree2: [],
			data2: [],
			firstActed: true,
			ccC: '',
			addFilevisit: false,
			addDocuvisit: false,
			addApplyvisit: false,
			currencyvisit: false,
			salaryvisit: false,
			sealvisit: false,
			adjustmentvisit: false,
			deptTree: [],
			plateNumberList: [],
			createBusinessList: checkPermission('activiti:BusinessList:create'),
			infoBusinessList: checkPermission('activiti:BusinessList:info'),
			cancelBusinessList: checkPermission('activiti:BusinessList:cancel'),
			deleteBusinessList: checkPermission('activiti:BusinessList:delete'),
			addBusinessList: checkPermission('activiti:BusinessList:add'),
			tenderLimitation: checkPermission('activiti:BusinessList:tender'),

			timeData: ''

		}
	},
	computed: {
		// rowSelection() {
		// 	return {
		// 		selectedRowKeys: this.selectedRowKeys,
		// 		onChange: this.onSelectChange,
		// 		getCheckboxProps: (record) => ({
		// 			props: {
		// 				disabled: record.status === 1, // Column configuration not to be checked
		// 				// name: record.name
		// 			},
		// 		}),
		// 	}
		// },
	},
	filters: {
		statusFilter(status) {
			return statusMap[status]
		},
		resultFilter(status) {
			return resultMap[status]
		},
		deptFilter(type) {
			return deptMap[type].text
		},
	},
	created() {
		getDeptListEnable().then((res) => {
			const data = res.rows
			if (data.length > 0) {
				const min = Math.min(...data.map((m) => m.parentId))
				this.buildtree2(data, this.deptTree, min)
				this.deptTree.map((d) => {
					if (d.hasOwnProperty('children')) {
						d.children.map((b) => {
							deptMap[b.key] = {
								text: b.title,
							}
							deptMap[d.key] = {
								text: d.title,
							}
						})
					} else {
						deptMap[d.key] = {
							text: d.title,
						}
					}
				})
				this.expandedKeys = data.map((m) => m.parentId)
				this.dataList = data.map((m) => {
					return {
						key: m.deptId,
						title: m.deptName,
					}
				})
			}
		})
		getDeptListEnable2().then((res) => {
			const data = res.rows
			if (data.length > 0) {
				const min = Math.min(...data.map((m) => m.parentId))
				this.buildtree2(data, this.deptTree2, this.$store.getters.userInfo.companyId)
			}
		})
		returnDept2((res) => {
			this.options = res.depts
		})
		audit_list().then(res => {
			if (res.code == 200) {
				this.Approvallist = res.data
			}
		})
		audit_list({
			source: 1
		}).then(res => {
			if (res.code == 200) {
				this.companyList1 = res.data

			}
		})
		get_dict('goodStatus', (res) => {
			this.statusMap = res
		})
		get_dept_tree().then((res) => {
			this.companylist = res.data.dept_lis
			this.companylist.unshift({
				dept_id: 0,
				dept_name: '所有公司',
				child_lis: [],
			})
		})
		this.getCompany()
		// tree_all().then((res) => {
		// 	if(res.code == 200) {
		// 		this.companylist2 = res.data[0]
		// 		console.log(this.companylist2, 'this.companylist2============================')

		// 	} else {
		// 		this.$message.error(res.msg)
		// 	}
		// })
		// get_dept_tree2().then((res) => {
		// 	this.companylist2 = res.data.dept_lis
		// })
		dict({
			pageNum: 1,
			pageSize: 10,
			dictType: 'assets_type',
		}).then((res) => {
			this.assettype = res.rows
			this.assettype.map((d) => {
				this.operTypeMap[d.dictCode] = {
					text: d.dictLabel,
				}
			})
		})
		
		this.get_acc()
	},
	mounted() {
		dict({
			pageNum: 1,
			pageSize: 10,
			dictType: 'seal_document',
		}).then((res) => {
			this.sealtype = res.rows
		})
		dict({
			pageNum: 1,
			pageSize: 10,
			dictType: 'seal_type',
		}).then((res) => {
			this.sealdocument = res.rows
		})
		this.$nextTick(() => {
			setTimeout(() => {
				var max_h = $('#content_main_center_scroll2').height()
				console.log(max_h,'scroll_yscroll_yscroll_yscroll_yscroll_y')
				setTimeout(() => {
					this.scroll_y = max_h - $('.ant-table-header').height() - 40
				}, 1000)
               console.log(max_h,this.scroll_y,'this.scroll_y===================')

			}, 1000)

		})
	},
	activated() {
		if (this.firstActed) {
			this.firstActed = false
		} else {
			this.handleOk()
		}
	},
	methods: {
		getCompany() {
			tree_all().then((res) => {
				if (res.code == 200) {
					this.companylist2 = res.data[0]
					this.companylist2.forEach((item) => {
						if (item.deptId == this.serviceform.companyId) {
							this.deptlist2 = item.children
							console.log(this.deptlist, 'deptlist===================')
						}
					})
					console.log(this.companylist2, 'this.companylist2============================')

				} else {
					this.$message.error(res.msg)
				}
			})

		},
		onChangeData(value, dateString) {
			this.returncarform.data = dateString
			this.returncarform.timeData = this.returncarform.data + " " + this.returncarform.time + ':00'
			console.log(dateString, 'this.data, this.datathis.datathis.datathis.datathis.data')
			console.log(this.timeData, 'timeData,')

		},
		onChangeTime(value) {
			this.returncarform.time = value
			this.returncarform.timeData = this.returncarform.data + " " + this.returncarform.time + ':00'
			console.log(this.returncarform.time, 'this.form.time ')
			console.log(this.timeData, 'this.timeData ')

		},
		paymentClose() {
			this.approvalId = undefined
			this.payment_visible = false

		},
		reimburseClose() {
			this.approvalId = undefined
			this.reimburse_visible = false
		},
		getIdData(data) {
			this.idList = data
			console.log(data, 'data=====================')

		},
		//选择公章取消默认抄送人
		choseSealType(e) {
			this.carbon = e
			console.log(this.sealform.cc, 'this.sealform.cc==============================')

		},
		addImages() {
			this.addDocuvisit = false

		},
		filterOption(input, option) {
			return (
				option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
			);
		},
		useCarDateChange(value, dateString) {
			this.returncarform.useCarDate = dateString
		},
		feedback() {
			this.$refs.feedbackapplication.show()
		},
		listNow() {
			if (this.plateNumberList2.length == 0) {
				this.$message.error('请先选择您的出行日期!')
			}
		},
		changeDateList(date) {
			biz_car_registration_list({
				goToDate: date
			}).then((res) => {
				if (res.code == 200) {
					this.plateNumberList2 = res.rows
				} else {
					this.plateNumberList2 = []
				}
			})
		},
		ccsd() {
			this.$forceUpdate()
		},
		ccsds() {
			this.returncarform.plateNumber = undefined
			this.$forceUpdate()
		},
		//车牌号改变
		changePlateNum($event) {
			this.plateNumberList.forEach((item) => {
				if (item.plateNumber == $event) {
					this.returncarform.latestMileage = item.latestMileage ? item.latestMileage : 0
					this.returncarform.goMileage = item.latestMileage ? item.latestMileage : 0
					this.returncarform.goMileage = this.returncarform.latestMileage
					this.$forceUpdate()
				}
			})
		},
		disabledDate(current) {
			return current < moment().subtract(2, 'day');
		},
		//添加加油详情
		addPush() {
			this.returncarform.oils.push({
				fuelMileage: '',
				fuelMoney: '',
				key: Date.now(),
			})
			this.$forceUpdate()
		},
		//删除
		delItemOils(idx) {
			this.returncarform.oils.splice(idx, 1)
			this.$forceUpdate()
		},
		returncarMoney() {
			var num = 0
			this.returncarform.oils.forEach((item) => {
				num += item.fuelMoney ? Number(item.fuelMoney) : 0
			})
			this.returncarform.money = num
			this.returncarform.capitalizeMoney = this.convertCurrency(this.returncarform.money)
			this.$forceUpdate()
		},
		changtravel() {
			this.returncarform.travelMileage = ''
			this.ccsd()
			var back = this.returncarform.backMileage
			var go = this.returncarform.goMileage
			if (back && go) {
				this.returncarform.travelMileage = back - go
				this.returncarform.travelMileage = this.returncarform.travelMileage.toFixed(2)
			}
		},
		mImgadd() {
			this.mImg++
		},
		mImgreduce() {
			this.mImg--
		},
		hImgadd() {
			this.hImg++
		},
		hImgreduce() {
			this.hImg--
		},
		nImgadd() {
			this.nImg++
		},
		nImgreduce() {
			this.nImg--
		},
		handleOkreturnCar() {
			this.$refs.hcruleForm.validate((valid) => {
				if (this.auditCodeData.length == 0 && this.auditCodeData2.length == 0 && this.auditCodeData3.length == 0 && this.auditCodeData4.length == 0) {
					this.$message.error('请先关联审批单')
					return
				}
				if (this.mImg == 0) {
					this.$message.error('请上传出车前后里程照片')
					return
				}
				if (this.hImg == 0) {
					this.$message.error('请上传出车后车内外卫生照片')
					return
				}
				if (valid) {
					this.returncarform['associateApply'] = []
					this.auditCodeData.forEach(item => {
						console.log(item)
						this.returncarform['associateApply'].push({
							associateTitle: item.processName,
							associateTypes: item.processDefKey,
							associateApply: item.businessKey,
							applyCode: item.applyCode,
						})
					})
					this.auditCodeData2.forEach(item => {
						console.log(item)
						this.returncarform['associateApply'].push({
							associateTitle: item.title,
							associateTypes: item.procDefKey,
							associateApply: item.businessKey,
							applyCode: item.applyCode,
						})
					})
					this.auditCodeData3.forEach(item => {
						console.log(item)
						this.returncarform['associateApply'].push({
							associateTitle: item.title,
							associateTypes: item.procDefKey,
							associateApply: item.id,
							applyCode: item.applyCode,
						})
					})
					this.auditCodeData4.forEach(item => {
						console.log(item)
						this.returncarform['associateApply'].push({
							associateTitle: item.title,
							associateTypes: item.procDefKey,
							associateApply: item.businessKey,
							applyCode: item.applyCode,
						})
					})
					this.returncarform.belongCompanyId = this.$store.getters.userInfo.companyId
					this.returncarform.cc = this.returncarform.cc.length ? this.returncarform.cc.join(',') : ''
					biz_car_subsidy_apply_save(this.returncarform).then((res) => {
						this.returncarvisible = false
						if (res.code == 200) {
							this.$message.success('添加成功')
						} else {
							this.$message.error(res.msg)
							return
						}
					})
				}
			})
		},
		handleOkCar() {
			this.$refs.ycruleForm.validate((valid) => {
				if (valid) {
					this.carform.companyUseId = this.$store.getters.userInfo.companyId
					this.carform.cc = this.carform.cc.length ? this.carform.cc.join(',') : ''
					biz_car_apply_save(this.carform).then((res) => {
						this.carvisible = false
						if (res.code == 200) {
							this.$message.success('添加成功')
						} else {
							this.$message.error(res.msg)
							return
						}
					})
				}
			})
		},
		changelate($event) {
			this.plateNumberList.forEach((item) => {
				if (item.plateNumber == $event) {
					this.carform.latestMileage = item.latestMileage == null ? 0 : item.latestMileage
				}
			})
		},
		changeTime() {
			var T = moment(this.carform.goToDate).valueOf()
			var B = moment(this.carform.goBackDate).valueOf()
			if (B < T) {
				this.carform.goBackDate = ''
				this.$message.error('预计回程日期不能小于预计出行日期');
			}
			var time = parseInt((B - T) / (1000 * 3600 * 24)) + 1
			this.carform.days = time
		},
		changeTime2() {
			var T = moment(this.carform.goToDate).valueOf()
			var B = moment(this.carform.goBackDate).valueOf()
			if (T > B) {
				this.carform.goToDate = ''
				this.$message.error('预计出行日期不能大于预计回程日期');
			}
			var time = parseInt((B - T) / (1000 * 3600 * 24)) + 1
			this.carform.days = time
		},
		changgBDate(value, dateString) {
			this.carform.goBackDate = dateString
			if (this.carform.goBackDate && this.carform.goToDate) {
				this.changeTime()
			}
		},
		changgTDate(value, dateString) {
			this.carform.goToDate = dateString
			this.changeDateList(dateString + ' 00:00:00')
			if (this.carform.goBackDate && this.carform.goToDate) {
				this.changeTime2()
			}
		},
		addNumber() {
			this.number++
		},
		reduceNumber() {
			this.number--
		},
		changeadjustedCapital() {
			this.adjustmentform.adjustedCapital = this.convertCurrency(this.adjustmentform.adjustedSalary)
		},
		changeoriginalCapital() {
			this.adjustmentform.originalCapital = this.convertCurrency(this.adjustmentform.originalSalary)
		},
		buildtree2(list, arr, parentId) {
			list.forEach((item) => {
				if (item.parentId === parentId) {
					var child = {
						key: item.deptId,
						value: item.deptId, // value是给modal的select用的，2者属性不一样
						title: item.deptName,
						scopedSlots: {
							title: 'title',
						},
						children: [],
					}
					this.buildtree2(list, child.children, item.deptId)
					if (child.children.length === 0) {
						delete child.children
					}
					arr.push(child)
				}
			})
		},
		buildtree2(list, arr, parentId) {
			list.forEach((item) => {
				if (item.parentId === parentId) {
					var child = {
						key: item.deptId,
						value: item.deptId, // value是给modal的select用的，2者属性不一样
						title: item.deptName,
						scopedSlots: {
							title: 'title',
						},
						children: [],
					}
					this.buildtree2(list, child.children, item.deptId)
					if (child.children.length === 0) {
						delete child.children
					}
					arr.push(child)
				}
			})
		},
		get_lis2() {
			// assetget_list2
			daily_list({
				pageSize: this.pagination2.pageSize,
				pageNum: this.pagination2.current,
				name: this.scrapPara.name,
				asset_sn: this.scrapPara.asset_sn,
				charger: this.scrapPara.charger,
				discard: 1,
				// page_size: this.pagination2.pageSize,
				// page_num: this.pagination2.current,
				// name: this.scrapPara.name,
				// asset_sn: this.scrapPara.asset_sn,
				// discard: 1,
			}).then((res) => {
				const pagination2 = {
					...this.pagination2
				}
				pagination2.total = res.total
				this.pagination2 = pagination2
				this.data2 = res.rows
				// const pagination2 = {
				// 	...this.pagination2
				// }
				// pagination2.total = res.data.total
				// this.pagination2 = pagination2
				// this.data2 = res.data.items
				// this.data2.forEach((item) => {
				// 	item.purchase_price = item.purchase_price / 100
				// 	item.value = item.value / 100
				// })
			})
		},
		//改变分页
		handleTableChange2(pagination, filters, sorter) {
			this.pagination2.current = pagination.current
			this.get_lis2()
		},
		scrapquery() {
			this.pagination2.current = 1
			this.get_lis2()
		},
		serhandlecompanyplan(e) {
			this.deptlist = []
			this.serviceform.deptId = undefined
			console.log(this.companylist2, 'companylist2===================')
			this.companylist2.forEach((item) => {
				if (item.deptId == this.serviceform.companyId) {
					this.deptlist = item.children

					console.log(this.deptlist, 'deptlist===================')
				}
			})
		},
		serchangeMoneyTotal() {
			this.serviceform.amountTotal = 0
			if (this.serviceform.types == 1) {
				this.serviceform.bizReviewInfos.forEach(item => {
					this.serviceform.amountTotal += Number(item.reviewAmount)
				})
			} else if (this.serviceform.types == 2) {
				this.serviceform.bizReviewInfos.forEach(item => {
					this.serviceform.amountTotal += Number(item.reviewAmount)
				})
			} else if (this.serviceform.types == 3) {
				this.serviceform.bizReviewInfos.forEach(item => {
					this.serviceform.amountTotal += Number(item.reviewAmount)
				})
			}
			this.serviceform.amountTotal = this.serviceform.amountTotal.toFixed(2)
			this.moneY = this.serviceform.amountTotal
		},
		//删除明细
		close_detaile(index) {
			console.log(this.serviceform.bizReviewInfos)
			this.serviceform.bizReviewInfos.splice(index, 1)
			this.serchangeMoneyTotal()
		},
		close_service(index) {
			this.serviceform.bizReviewInfos.splice(index, 1)
			this.serchangeMoneyTotal()
		},
		close_other(index) {
			this.serviceform.bizReviewInfos.splice(index, 1)
			this.serchangeMoneyTotal()
		},
		typesChange() {
			this.serviceform.bizReviewInfos = [{}]
			this.serchangeMoneyTotal()
		},
		seradd_detail() {
			this.serviceform.bizReviewInfos.push({
				projectCode: '',
				inspectedUnit: '',
				reviewDate: '',
				reviewAmount: '',
				expertNum: '',
				remark: '',
				projectUser: '',
			})
		},
		seradd_service() {
			this.serviceform.bizReviewInfos.push({
				projectCode: '',
				inspectedUnit: '',
				contractAmount: '',
				amountDate: '',
				reviewAmount: '',
				remark: '',
			})
		},
		seradd_other() {
			this.serviceform.bizReviewInfos.push({
				amountDetails: '',
				reviewAmount: '',
				remark: '',
			})
		},
		projectPricechange() {
			this.moneY = this.operationform.projectPrice
		},
		contractAmountchange() {
			this.moneY = this.form.contractAmount
		},
		handlecompanyplan(e) {
			console.log(e, 'e========================')
			this.deptlist2 = []
			this.paymentform.subjectionDeptId = undefined
			this.$nextTick(() => {
				this.companylist2.forEach((item) => {
					if (item.deptId == e) {
						this.deptlist2 = item.children
						this.paymentform.companyName = item.title
					}
				})
			})
		},
		changeDept(e) {
			console.log(e, 'e========================')
			this.deptlist2.forEach((item) => {
				if (item.deptId == e) {
					this.paymentform.subjectionDeptName = item.title
				}
			})
		},
		close_detail(index) {
			this.reimburseform.reimburseDetails.splice(index, 1)
			this.changeMoneyTotal()
		},
		close_detail2(index) {
			this.paymentform.paymentDetails.splice(index, 1)
			this.inputEnter()
		},
		inputEnter() {
			this.paymentform.payCount = 0
			this.paymentform.paymentDetails.forEach((item) => {
				this.paymentform.payCount += Number(item.thisPayment)
			})
			this.paymentform.payCount = this.paymentform.payCount.toFixed(2)
			this.moneY = this.paymentform.payCount
		},
		changeMoneyTotal() {
			this.reimburseform.reimburseMoneyTotal = 0
			this.reimburseform.reimburseDetails.forEach(item => {
				this.reimburseform.reimburseMoneyTotal += Number(item.money)
			})
			this.reimburseform.reimburseMoneyTotal = this.reimburseform.reimburseMoneyTotal.toFixed(2)
			this.moneY = this.reimburseform.reimburseMoneyTotal
		},
		//获取账号
		getPay(data) {
			get_accounts_receivable().then((res) => {
				res.data.forEach(item => {
					if (item.id == data) {
						console.log(item)
						this.paymentform.accountType = item.accountType
						this.paymentform.name = item.name
						this.paymentform.accountNum = item.accountNum
						this.paymentform.bank = item.bank
						this.paymentform.province = item.province
						this.paymentform.city = item.city
						this.paymentform.provinceName = item.provinceName
						this.paymentform.cityName = item.cityName
						this.paymentform.branchBank = item.branchBank
					}
				})
			})
			return

		},
		serviceOk() {
			this.$refs.psruleForm.validate(valid => {
				if (valid) {
					this.serviceform.title = this.$store.getters.userInfo.userName
					this.serviceform.cc = this.serviceform.cc.length ? this.serviceform.cc.join(',') : ''
					console.log(this.serviceform)
					review_apply_save(this.serviceform).then(res => {
						if (res.code === 200) {
							this.$message.success('保存成功')
							this.$emit('ok')
							this.service_visit = false
							this.$refs.table.refresh(true)
						} else {
							this.$message.error(res.msg)
							this.isRouterAlive = false
							this.$nextTick(() => {
								this.isRouterAlive = true
							})
						}
					})
				}
			})
		},
		sealOk() {

			this.$refs.yyruleForm.validate((valid) => {
				if (this.number == 0) {
					this.$message.error('请上传附件')
					return
				}
				if (valid) {
					this.sealform.cc = this.sealform.cc.length ? this.sealform.cc.join(',') : ''
					seal_apply_save(this.sealform).then(res => {
						if (res.code == 200) {
							this.sealvisit = false
							this.$message.success('提交成功！')
							this.$refs.table.refresh(true)
							this.addApplyvisit = false
						} else {
							this.$message.error(res.msg)
						}
					})
				}
			})
		},
		currencyOk() {
			this.$refs.tyruleForm.validate((valid) => {
				if (valid) {
					this.currencyform.cc = this.currencyform.cc.length ? this.currencyform.cc.join(',') : ''

					if (this.timeout) {
						clearTimeout(this.timeout)
					}
					this.timeout = setTimeout(() => {
						console.log(this.answer)
						universal_apply_save(this.currencyform).then(res => {
							if (res.code == 200) {
								this.currencyvisit = false
								this.$message.success('提交成功！')
								this.$refs.table.refresh(true)
								this.addApplyvisit = false
							} else {
								this.$message.error(res.msg)
							}
						})







					}, 500);

				}
			})
		},
		adjustmentOk() {
			this.$refs.txruleForm.validate((valid) => {
				if (valid) {
					this.adjustmentform.cc = this.adjustmentform.cc.length ? this.adjustmentform.cc.join(',') :
						''
					salary_adjustment_save(this.adjustmentform).then(res => {
						if (res.code == 200) {
							this.adjustmentvisit = false
							this.$message.success('提交成功！')
							this.$refs.table.refresh(true)
							this.addApplyvisit = false
						} else {
							this.$message.error(res.msg)
						}
					})
				}
			})
		},
		salaryOk() {
			this.$refs.xzruleForm.validate((valid) => {
				if (valid) {
					this.salaryform.cc = this.salaryform.cc.length ? this.salaryform.cc.join(',') : ''
					salary_approval_save(this.salaryform).then(res => {
						if (res.code == 200) {
							this.salaryvisit = false
							this.$message.success('提交成功！')
							this.$refs.table.refresh(true)
							this.addApplyvisit = false
						} else {
							this.$message.error(res.msg)
						}
					})
				}
			})
		},
		//点击领用出库
		apply_delivery: debounce(function () {
			this.$refs.lyruleForm.validate((valid) => {
				if (valid) {
					this.receiveform.old_goods = []
					this.receiveform.newgoods = []
					this.receiveform.goods.forEach(item => {
						this.receiveform.old_goods.push({
							name: item.aaSpu.name,
							model: item.aaSpu.model,
							is_inspected: item.aaSpu.isInspected,
							delivery_amount: item.claimNum,
							unit: item.aaSpu.unit,
						})
						this.receiveform.newgoods.push({
							goodsId: item.goodsId,
							claimNum: item.claimNum,
						})
					})
					this.receiveform.goods = this.receiveform.newgoods
					this.receiveform.cc = this.receiveform.cc.length ? this.receiveform.cc.join(',') :
						''
					claim_apply(this.receiveform).then((res) => {
						if (res.code != 200) {
							this.$message.error(res.msg)
							return
						}
						this.$message.success('申领成功')
						this.$refs.table.refresh(true)
						this.is_apply_show = false
					})
				} else {
					console.log('error submit!!')
					return false
				}
			})
		}, 1000, {
			'leading': true,
			'trailing': false
		}),
		//点击退货出库
		returnOk: debounce(function () {
			var _this = this
			this.$refs.thruleForm.validate((valid) => {
				if (valid) {
					var lis = []
					_this.returnform.goodsRejectedDetailList.forEach(item => {
						lis.push({
							assertId: item.id,
							num: item.num,
							remarks: item.remarks,
							itemType: item.itemType,
							purchaseCode: item.purchaseCode,
						})
					})
					goods_rejected_save({
						cc: _this.returnform.cc.length ? _this.returnform.cc.join(',') : '',
						goodsRejectedDetailList: lis,
						applyCode: _this.returnform.applyCode,
						returnReason: _this.returnform.returnReason
					}).then((res) => {
						if (res.code != 200) {
							this.$message.error(res.msg)
							return
						}
						this.$message.success('提交成功')
						this.$refs.table.refresh(true)
						this.return_visible = false
					})
				} else {
					console.log('error submit!!')
					return false
				}
			})
		}, 1000, {
			'leading': true,
			'trailing': false
		}),
		onSelectChange(selectedRowKeys) {
			console.log(selectedRowKeys, this.data2, '==============================')
			this.selectedRowKeys2 = selectedRowKeys
			var str = selectedRowKeys.toString()
			this.data2.forEach(item => {
				if (item.id == str) {
					this.moneY = item.purchase_price
				}
			})
		},
		//关闭弹窗
		cancelEvent() {
			this.$refs.bfruleForm.resetFields()
			this.scrap_visit = false
			this.scrapform = {
				cc: [], //抄送人
				title: '',
				assertId: '',
				remark: '',
				scrappedPrice: '',
				dealMethod: '',
				realPrice: '',
				rcvMethod: undefined,
			}
		},
		//提交
		scrapOk: debounce(function () {
			var _this = this
			// if(this.selectedRowKeys2=[]){
			// 	this.boole=true
			// }else{
			if (this.selectedRowKeys2.length == 0) {
				this.hasSelectedAssert = true
				return false
			}
			this.$refs.bfruleForm.validate((valid) => {
				if (valid) {
					this.selectedRowKeys2.forEach((item) => {
						_this.scrapform.assertId = item
					})
					scrapped_apply({
						cc: _this.scrapform.cc.length ? this.scrapform.cc.join(',') : '',
						assertId: _this.scrapform.assertId,
						remark: _this.scrapform.remark,
						scrappedPrice: _this.scrapform.scrappedPrice,
						dealMethod: _this.scrapform.dealMethod,
						realPrice: _this.scrapform.realPrice,
						rcvMethod: _this.scrapform.rcvMethod,
					}).then((res) => {
						console.log(res)
						if (res.code != 200) {
							this.$message.error(res.msg)
							return
						}
						this.$message.success('新增成功！')
						this.selectedRowKeys2 = []
						this.hasSelectedAssert = false
						this.$refs.table.refresh(true)
						this.scrap_visit = false
					})
				} else {
					console.log('error submit!!')
					return false
				}
			})
		}, 1000, {
			'leading': true,
			'trailing': false
		}),
		operationOk: debounce(
			function () {
				this.$refs.ywfruleForm.validate((valid) => {
					if (valid) {
						this.operationform.title = this.$store.getters.userInfo.userName
						this.operationform.cc = this.operationform.cc.length ? this.operationform.cc.join(
							',') : ''
						this.operationform.ifOld = Number(this.operationform.ifOld)
						apply_save(this.operationform)
							.then((res) => {
								if (res.code === 200) {
									this.$message.success('提交成功')
									this.$refs.table.refresh(true)
									this.operation_visible = false
								} else {
									this.$message.error(res.msg)
								}
							})
							.catch(() => {
								this.$message.error('系统错误，请稍后再试')
							})
					}
				})
			},
			1000, {
			leading: true,
			trailing: false,
		}
		),
		stampDateChange(date) {
			this.sealform.stampDate = date
		},
		leaderid(id) {
			get_users2(id, (res) => {
				this.plainOptions = res
				console.log(this.plainOptions, 'plainOptions==================')

			})
		},
		seal() {
			console.log(this.companylist, 'this.companylist=======================')
			this.isRouterAlive = false
			this.$nextTick(() => {
				this.isRouterAlive = true
			})
			this.sealform = {
				cc: [],
				applyCode: '',
				userDept: undefined,
				sealUser: undefined,
				stampDate: '',
				document: '',
				documentNum: '',
				documentType: undefined,
				sealType: undefined,
				remark: '',
			}
			this.sealvisit = true
			console.log(this.companylist, 'this.companylist=======================')
			this.companylist.forEach((item) => {
				if (item.dept_id == this.$store.getters.userInfo.companyId) {
					this.deptlist = item.child_lis
				}
			})
			seal_apply_code().then(res => {
				this.sealform.applyCode = res.data
				this.uploadData.code = res.data
				this.uploadDataImg.code = res.data
			})
			this.ccC = 'seal'
			this.uploadData.type = 'seal-appendix'
			this.uploadDataImg.type = 'seal-certificate'
		},
		salary() {
			this.isRouterAlive = false
			this.$nextTick(() => {
				this.isRouterAlive = true
			})
			this.salaryform = {}
			this.salaryvisit = true
			salary_approval_code().then(res => {
				this.salaryform.applyCode = res.data
				this.uploadData.code = res.data
				this.uploadDataImg.code = res.data
			})
			this.ccC = 'xz_approval'
			this.uploadData.type = 'xzhz-appendix'
			this.uploadDataImg.type = 'xzhz-certificate'
		},
		adjustment() {
			this.isRouterAlive = false
			this.$nextTick(() => {
				this.isRouterAlive = true
			})
			this.adjustmentform = {}
			this.adjustmentvisit = true
			salary_adjustment_code().then(res => {
				console.log(res, 12)
				this.adjustmentform.applyCode = res.data
				this.uploadData.code = res.data
				this.uploadDataImg.code = ''
			})
			this.ccC = 'xz_adjustment'
			this.uploadData.type = 'xztz-appendix'
			this.uploadDataImg.type = ''
		},
		currency() {
			this.isRouterAlive = false
			this.$nextTick(() => {
				this.isRouterAlive = true
			})
			this.currencyform = {
				cc: [],
				applyCode: '',
				content: '',
				detail: '',
			}
			this.currencyvisit = true
			universal_apply_code().then(res => {
				this.currencyform.applyCode = res.data
				this.uploadData.code = res.data
				this.uploadDataImg.code = res.data
			})
			this.ccC = 'universal'
			this.uploadData.type = 'universal-appendix'
			this.uploadDataImg.type = 'universal-certificate'
		},
		currencySalary() {
			// this.isRouterAlive = false
			
			this.$nextTick(() => {
				this.$refs.salary.init()
			})
		},
		//刷新列表
		refreshList(data) {
			this.addApplyvisit = data
			this.$refs.table.refresh(true)
		},
		addApply() {
			this.addApplyvisit = true
		},
		addDocuments(record) {
			if (record.procDefKey.indexOf("payment-") == 0) {
				this.imgDataApply.parent = record.tableId
				this.fileDataApply.code = record.tableId
				this.addFilevisit = true

			} else {
				this.uploadDataImgAddm.type = ''
				this.uploadDataImgAddh.type = ''
				this.uploadDataImgAddn.type = ''
				this.uploadDataImgAddm.parent = ''
				this.uploadDataImgAddh.parent = ''
				this.uploadDataImgAddn.parent = ''
				this.uploadDataAdd.type = ''
				this.uploadDataImgAdd.type = ''
				this.uploadDataAdd.parent = ''
				this.uploadDataImgAdd.parent = ''
				this.addDocuvisit = true
				this.isRouterAlive = false
				this.$nextTick(() => {
					this.isRouterAlive = true
				})
				console.log(record,'=============')
				//合同审批详情
				if (record.procDefKey == 'contract_ys') {
					contract_apply_get(record.id).then(res => {
						this.uploadDataAdd.parent = res.data.id
						this.uploadDataImgAdd.parent = res.data.id
					})
					this.uploadDataAdd.type = 'contract-file'
					this.uploadDataImgAdd.type = 'contract-img'
				} else if (record.procDefKey == 'reimburse') {
					getReimburseApply(record.id).then(res => {
						this.uploadDataAdd.parent = res.data.id
						this.uploadDataImgAdd.parent = res.data.id
					})
					this.uploadDataAdd.type = 'reimburse-appendix'
					this.uploadDataImgAdd.type = 'reimburse-certificate'
				} else if (record.procDefKey == 'payment') {
					payment_apply_get(record.id).then(res => {
						this.uploadDataAdd.parent = res.data.id
						this.uploadDataImgAdd.parent = res.data.id
					})
					this.uploadDataAdd.type = 'payment-appendix'
					this.uploadDataImgAdd.type = 'payment-certificate'
				} else if (record.procDefKey == 'businessMoney') {
					getBusinessFeeApply(record.id).then(res => {
						this.uploadDataAdd.parent = res.data.id
					})
					this.uploadDataAdd.type = 'business-fee'
				} else if (record.procDefKey == 'review') {
					getReviewApply(record.id).then(res => {
						this.uploadDataImgAdd.parent = res.data.id
					})
					this.uploadDataImgAdd.type = 'review'
				} else if (record.procDefKey == 'seal') {
					seal_apply_get(record.id).then(res => {
						this.uploadDataAdd.parent = res.data.id
						this.uploadDataImgAdd.parent = res.data.id
					})
					this.uploadDataAdd.type = 'seal-appendix'
					this.uploadDataImgAdd.type = 'seal-certificate'
				} else if (record.procDefKey == 'universal') {
					universal_apply_get(record.id).then(res => {
						this.uploadDataAdd.parent = res.data.id
						this.uploadDataImgAdd.parent = res.data.id
					})
					this.uploadDataAdd.type = 'universal-appendix'
					this.uploadDataImgAdd.type = 'universal-certificate'
				} else if (record.procDefKey == 'goodsRejected') {
					goods_rejected_info(record.id).then(res => {
						this.uploadDataAdd.parent = res.data.id
						this.uploadDataImgAdd.parent = res.data.id
					})
					this.uploadDataAdd.type = 'goods-rejected-file'
					this.uploadDataImgAdd.type = 'goods-rejected-img'
				} else if (record.procDefKey == 'carSubsidyApply') {
					this.pushImages = true
					returnCarApply(record.id).then(res => {
						this.uploadDataImgAddm.parent = res.data.id
						this.uploadDataImgAddh.parent = res.data.id
						this.uploadDataImgAddn.parent = res.data.id
					})
					this.uploadDataImgAddm.type = 'mileage-imgs'
					this.uploadDataImgAddh.type = 'hygiene-imgs'
					this.uploadDataImgAddn.type = 'navigation-imgs'
				} else if (record.procDefKey == 'xz_adjustment') {
					salary_adjustment_get(record.id).then(res => {
						this.uploadDataAdd.parent = res.data.id
					})
					this.uploadDataAdd.type = 'xztz-appendix'
				} else if (record.procDefKey == 'xz_approval') {
					salary_approval_get(record.id).then(res => {
						this.uploadDataAdd.parent = res.data.id
						this.uploadDataImgAdd.parent = res.data.id
					})
					this.uploadDataAdd.type = 'xzhz-appendix'
					this.uploadDataImgAdd.type = 'xzhz-certificate'
				} else if (record.procDefKey == 'cover') {
					getCoverApply(record.id).then(res => {
						this.uploadDataImgAdd.parent = res.data.id
					})
					this.uploadDataImgAdd.type = 'cover'
				} else if (record.procDefKey == 'other-charge') {
					getOtherApply(record.id).then(res => {
						this.uploadDataImgAdd.parent = res.data.id
					})
					this.uploadDataImgAdd.type = 'other-charge'
				} else if (record.procDefKey == 'feedback') {
					feedback_get(record.id).then(res => {
						this.uploadDataAdd.parent = res.data.id
						this.uploadDataImgAdd.parent = res.data.id
					})
					this.uploadDataAdd.type = 'feedback-appendix'
					this.uploadDataImgAdd.type = 'feedback-certificate'
				} else if (record.procDefKey == 'pr_amount') {
					//获得详情页面数据
					salaryDetail(record.id).then(res => {
							this.uploadDataAdd.parent = res.data.id
					})
					console.log(this.uploadDataAdd.parent, 'this.uploadDataAdd.parent========')
					this.uploadDataAdd.type = 'xmxg-appendix'

				}
			}
		},
		delete_auditCode(index) {
			this.auditCodeData.splice(index, 1)
			console.log(this.auditCodeData)
		},
		delete_auditCode2(index) {
			this.auditCodeData2.splice(index, 1)
			console.log(this.auditCodeData)
		},
		delete_auditCode3(index) {
			this.auditCodeData3.splice(index, 1)
			console.log(this.auditCodeData)
		},
		delete_auditCode4(index) {
			this.auditCodeData4.splice(index, 1)
			console.log(this.auditCodeData)
		},
		handelAudit(index) {
			var record = this.auditCodeData[index]
			const modal = modalMap[record.processDefKey]
			console.log(record, modal)
			this.$refs[modal].show({
				businessKey: record.businessKey,
			})
		},
		handelAudit2(index) {
			var record = this.auditCodeData2[index]
			const modal = modalMap[record.procDefKey]
			console.log(modal)
			this.$refs[modal].show({
				businessKey: record.businessKey,
			})
		},
		handelAudit3(index) {
			var record = this.auditCodeData3[index]
			const modal = modalMap[record.procDefKey]
			console.log(modal)
			this.$refs[modal].show({
				businessKey: record.id,
			})
		},
		handelAudit4(index) {
			var record = this.auditCodeData4[index]
			const modal = modalMap[record.procDefKey]
			console.log(modal)
			this.$refs[modal].show({
				businessKey: record.businessKey,
			})
		},
		//获取code
		getAppCode(data) {
			this.auditCodeData = data
			// console.log(data, 'data==================================')
			// console.log(this.auditCodeData, 'this.auditCodeData==================================')
			// 		if(this.kind == 1) {
			// 			this.arrPurshe = data
			// 		} else {
			// 			this.arrApply = data
			// 		}
			// 		console.log('99999999999999999999')
			// data.forEach(item => {
			// 	 this.auditCodeData.push(item)

			// })
		},
		getAppCode2(data) {
			// if(this.kind == 1) {
			// 			this.arrPurshe2 = data
			// 		} else {
			// 			this.arrApply2= data
			// 		}
			// 	console.log(data, 'data==================================')
			// 	data.forEach(item => {
			// 		console.log('666666666666666666666666666666666')
			// this.auditCodeData2.push(item) 
			// })
			this.auditCodeData2 = data
		},
		getAppCode3(data) {
			// if(this.kind == 1) {
			// 			this.arrPurshe3 = data
			// 		} else {
			// 			this.arrApply3 = data
			// 		}
			// 	console.log(data, 'data==================================')
			// 	data.forEach(item => {
			// 		console.log('666666666666666666666666666666666')
			// this.auditCodeData3.push(item) 
			// })
			this.auditCodeData3 = data
		},
		getAppCode4(data) {
			// if(this.kind == 1) {
			// 			this.arrPurshe4 = data
			// 		} else {
			// 			this.arrApply4 = data
			// 		}
			// 	console.log(data, 'data==================================')
			// 	data.forEach(item => {
			// 		console.log('666666666666666666666666666666666')
			// this.auditCodeData4.push(item) 
			// })
			this.auditCodeData4 = data
		},
		getApplyAll(data) {
			if (data.length > 1) {
				this.auditCodeData = []
				this.auditCodeData2 = []
				this.auditCodeData3 = []
				this.auditCodeData4 = []
				this.$message.error('只可关联一条')
			} else {
				this.$message.success('关联成功')
				getCarApply(data[0].id).then(res => {
					this.returncarform.plateNumber = res.data.plateNumber
					this.returncarform.latestMileage = res.data.latestMileage ? res.data.latestMileage : 0
					this.returncarform.belongDeptId = res.data.deptUseId
					this.returncarform.carTypes = res.data.carTypes
					this.returncarform.destination = res.data.prefecture
					this.returncarform.goMileage = this.returncarform.latestMileage
					this.$forceUpdate()
				})
			}
		},
		showAuditCode() {
			this.kind = 0
			this.typeIndex = 2
			// 	this.arrApply.forEach(item => {
			// 	for(var i = this.auditCodeData.length-1; i >=0 ; i--) {
			// 		if(item.businessKey == this.auditCodeData[i].businessKey) {
			// 			this.auditCodeData.splice(i,1)
			// 		} 
			// 	}
			// })
			// 	this.arrApply2.forEach(item => {
			// 	for(var i = this.auditCodeData2.length-1; i >=0 ; i--) {
			// 		if(item.businessKey == this.auditCodeData2[i].businessKey) {
			// 			this.auditCodeData2.splice(i,1)
			// 		} 
			// 	}
			// })
			// 	this.arrApply3.forEach(item => {
			// 	for(var i = this.auditCodeData3.length-1; i >=0 ; i--) {
			// 		if(item.businessKey == this.auditCodeData3[i].businessKey) {
			// 			this.auditCodeData3.splice(i,1)
			// 		} 
			// 	}
			// })
			// 	this.arrApply4.forEach(item => {
			// 	for(var i = this.auditCodeData4.length-1; i >=0 ; i--) {
			// 		if(item.businessKey == this.auditCodeData4[i].businessKey) {
			// 			this.auditCodeData4.splice(i,1)
			// 		} 
			// 	}
			// })
			// console.log(this.auditCodeData, 'this.auditCodeDatathis.auditCodeDatathis.auditCodeDatathis.auditCodeData')
			this.$refs.selectAuditCode.show({
				auditCodeData: this.auditCodeData,
				auditCodeData2: this.auditCodeData2,
				auditCodeData3: this.auditCodeData3,
				auditCodeData4: this.auditCodeData4,
				typeIndex: this.typeIndex
			})
		},
		showPurchase1() {
			this.kind = 1
			this.typeIndex = 1
			this.$refs.selectAuditCode.show({
				auditCodeData: this.auditCodeData,
				auditCodeData2: this.auditCodeData2,
				auditCodeData3: this.auditCodeData3,
				auditCodeData4: this.auditCodeData4,
				typeIndex: this.typeIndex
			})

		},
		showPurchase() {
			this.kind = 1
			this.typeIndex = 0
			// this.arrPurshe.forEach(item => {
			// 	for(var i = this.auditCodeData.length-1; i >=0 ; i--) {
			// 		if(item.businessKey == this.auditCodeData[i].businessKey) {
			// 			this.auditCodeData.splice(i,1)
			// 		} 
			// 	}
			// })
			// 	this.arrPurshe4.forEach(item => {
			// 	for(var i = this.auditCodeData4.length-1; i >=0 ; i--) {
			// 		if(item.businessKey == this.auditCodeData4[i].businessKey) {
			// 			this.auditCodeData4.splice(i,1)
			// 		} 
			// 	}
			// })
			// 	this.arrPurshe2.forEach(item => {
			// 	for(var i = this.auditCodeData2.length-1; i >=0 ; i--) {
			// 		if(item.businessKey == this.auditCodeData2[i].businessKey) {
			// 			this.auditCodeData2.splice(i,1)
			// 		} 
			// 	}
			// })
			// 	this.arrPurshe3.forEach(item => {
			// 	for(var i = this.auditCodeData3.length-1; i >=0 ; i--) {
			// 		console.log(item, 'item================================')
			// 		if(item.businessKey == this.auditCodeData3[i].businessKey) {
			// 			this.auditCodeData3.splice(i,1)
			// 		} 
			// 	}
			// })
			// console.log(this.auditCodeData, 'this.auditCodeDatathis.auditCodeDatathis.auditCodeDatathis.auditCodeData')
			// console.log(this.kind, 'this.kind ====================')
			this.$refs.selectAuditCode.show({
				auditCodeData: this.auditCodeData,
				auditCodeData2: this.auditCodeData2,
				auditCodeData3: this.auditCodeData3,
				auditCodeData4: this.auditCodeData4,
				typeIndex: this.typeIndex
			})
		},
		showAuditCode2() {
			this.returncarform.data = ''
			this.returncarform.time = ''
			this.$refs.selectAuditCode2.show()
		},
		callback(key) {
			this.typesnum = key
			this.bankform = {}
		},
		bankOk() {
			this.bankform['accountType'] = this.typesnum
			accounts_receivable_save(this.bankform).then(res => {
				if (res.code == 200) {
					this.bankvisible = false
					this.get_acc()
					this.bankform = {}
				}
			})
		},
		bankclear(id) {
			let list = []
			list.push(id)
			accounts_receivable_delete(list).then(res => {
				if (res.code == 200) {
					this.reimburseform.accountNum = undefined
					this.get_acc()
				}
			})
		},
		alert() {
			this.bankvisible = true
		},
		changeF() {
			this.bankshow = false
		},
		changeT() {
			this.bankshow = true
		},
		changeform(index) {
			console.log(index)
			this.bankshow = false
			this.banklist.forEach(item => {
				if (item.accountNum == index) {
					this.Select = item
				}
			})
		},
		get_acc() {
			get_accounts_receivable({
				types: 12
			}).then(res => {
				this.banklist = res.data
				console.log(this.banklist, 12334)
			})
		},
		//选择跟进人部门
		onChangeDept(value) {
			this.followers = []
			this.form.followerDept = value[1]
			get_users2(value[1], (res) => {
				this.form.follower = undefined
				res.forEach((item) => {
					item['label'] = item.userName
					item['value'] = item.userId
				})
				this.followers = res
			})
		},
		reimburseOk() {
			this.$refs.bxruleForm.validate((valid) => {
				if (valid) {
					console.log(this.Select)
					this.reimburseform['name'] = this.Select.name
					this.reimburseform['bank'] = this.Select.bank
					this.reimburseform['accountType'] = this.Select.accountType
					this.reimburseform['accountNum'] = this.Select.accountNum
					this.reimburseform['associateApply'] = []
					this.reimburseform['associatePurchaseApply'] = []
					// this.reimburseform['associatePurchaseApply'] = []
					this.auditCodeData.forEach(item => {
						if (item.processDefKey == 'purchase') {
							this.reimburseform['associatePurchaseApply'].push({
								associateTitle: item.processName,
								associateTypes: item.processDefKey,
								associateApply: item.businessKey,
								goodId: item.goodId.toString(),
								associateId: item.associateId,
							})
						} else {
							this.reimburseform['associateApply'].push({
								associateTitle: item.processName,
								associateTypes: item.processDefKey,
								associateApply: item.businessKey,

							})
						}
					})
					this.auditCodeData2.forEach(item => {
						if (item.procDefKey == 'purchase') {
							this.reimburseform['associatePurchaseApply'].push({
								associateTitle: item.title,
								associateTypes: item.procDefKey,
								associateApply: item.businessKey,
								goodId: item.goodId.toString(),
								associateId: item.associateId,
							})
						} else {
							this.reimburseform['associateApply'].push({
								associateTitle: item.title,
								associateTypes: item.procDefKey,
								associateApply: item.businessKey,

							})
						}
					})
					this.auditCodeData3.forEach(item => {
						if (item.procDefKey == 'purchase') {
							this.reimburseform['associatePurchaseApply'].push({
								associateTitle: item.title,
								associateTypes: item.procDefKey,
								associateApply: item.id,
								goodId: item.goodId.toString(),
								associateId: item.associateId,
							})
						} else {
							this.reimburseform['associateApply'].push({
								associateTitle: item.title,
								associateTypes: item.procDefKey,
								associateApply: item.id,
							})
						}
					})
					this.auditCodeData4.forEach(item => {
						if (item.processDefKey == 'purchase') {
							this.reimburseform['associatePurchaseApply'].push({
								associateTitle: item.processName,
								associateTypes: item.processDefKey,
								associateApply: item.businessKey,
								goodId: item.goodId.toString(),
								associateId: item.associateId,
							})
						} else {
							this.reimburseform['associateApply'].push({
								associateTitle: item.processName,
								associateTypes: item.processDefKey,
								associateApply: item.businessKey,

							})
						}
					})

					this.reimburseform.cc = this.reimburseform.cc.length ? this.reimburseform.cc.join(',') : ''
					reimburse_apply_save(this.reimburseform).then(res => {
						if (res.code == 200) {
							this.approvalId = undefined
							this.reimburse_visible = false
							this.$refs.table.refresh(true)
							this.$message.success('提交成功')
						} else {
							this.$message.error(res.msg)
							this.isRouterAlive = false
							this.$nextTick(() => {
								this.isRouterAlive = true
							})
						}
					})
				}
			})
		},
		paymentOk() {
			this.$refs.fkruleForm.validate((valid) => {
				if (!this.paymentform.accountNum) {
					this.$message.error('请选择账户类型！')
					return
				}
				if (valid) {
					this.paymentform['associateApply'] = []
					this.paymentform['associatePurchaseApply'] = []
					this.auditCodeData.forEach(item => {
						console.log(item)
						if (item.processDefKey == 'purchase') {
							this.paymentform['associatePurchaseApply'].push({
								associateTitle: item.processName,
								associateTypes: item.processDefKey,
								associateApply: item.businessKey,
								goodId: item.goodId.toString(),
								associateId: item.associateId,
							})
						} else {
							this.paymentform['associateApply'].push({
								associateTitle: item.processName,
								associateTypes: item.processDefKey,
								associateApply: item.businessKey,

							})
						}
					})
					this.auditCodeData2.forEach(item => {
						if (item.procDefKey == 'purchase') {
							this.paymentform['associatePurchaseApply'].push({
								associateTitle: item.title,
								associateTypes: item.procDefKey,
								associateApply: item.businessKey,
								goodId: item.goodId.toString(),
								associateId: item.associateId,
							})
						} else {
							this.paymentform['associateApply'].push({
								associateTitle: item.title,
								associateTypes: item.procDefKey,
								associateApply: item.businessKey,

							})
						}
					})
					this.auditCodeData3.forEach(item => {
						if (item.procDefKey == 'purchase') {
							this.paymentform['associatePurchaseApply'].push({
								associateTitle: item.title,
								associateTypes: item.procDefKey,
								associateApply: item.id,
								goodId: item.goodId.toString(),
								associateId: item.associateId,
							})
						} else {
							this.paymentform['associateApply'].push({
								associateTitle: item.title,
								associateTypes: item.procDefKey,
								associateApply: item.id,

							})
						}
					})
					this.auditCodeData4.forEach(item => {
						if (item.processDefKey == 'purchase') {
							this.paymentform['associatePurchaseApply'].push({
								associateTitle: item.processName,
								associateTypes: item.processDefKey,
								associateApply: item.businessKey,
								goodId: item.goodId.toString(),
								associateId: item.associateId,
							})
						} else {
							this.paymentform['associateApply'].push({
								associateTitle: item.processName,
								associateTypes: item.processDefKey,
								associateApply: item.businessKey,

							})
						}
					})



					this.paymentform.cc = this.paymentform.cc.length ? this.paymentform.cc.join(',') : ''
					payment_apply_save(this.paymentform).then((res) => {
						if (res.code != 200) {
							this.$message.error(res.msg)
							return
						}
						this.$message.success('提交成功')
						this.approvalId = undefined
						this.payment_visible = false
						this.$refs.table.refresh(true)
					})
				} else {
					console.log('error submit!!')
					return false
				}
			})
		},
		contractOk() {
			this.$refs.htruleForm.validate((valid) => {
				if (valid) {
					this.form.cc = this.form.cc.length ? this.form.cc.join(',') : ''
					contract_apply_save(this.form).then((res) => {
						if (res.code != 200) {
							this.$message.error(res.msg)
							return
						}
						this.$message.success('提交成功')
						this.is_show_apply = false
						this.$refs.table.refresh(true)
					})
				} else {
					console.log('error submit!!')
					return false
				}
			})
		},
		//提交
		handleOkAdd: debounce(
			function () {
				var _this = this
				this.$refs.cgruleForm.validate((valid) => {
					if (valid) {
						var is = true
						var lis = _this.info.bizGoodsInfos
						lis.forEach((item) => {
							item['expectDate'] = _this.info.expectDate
							item['itemType'] = _this.info.itemType
							item['ascriptionDept'] = _this.info.ascriptionDept
						})
						purchase_save({
							cc: _this.info.cc.length ? this.info.cc.join(',') : '',
							bizGoodsInfos: lis,
							remark: _this.info.remark,
						}).then((res) => {
							console.log(res)
							if (res.code != 200) {
								this.$message.error(res.msg)
								this.isRouterAlive = false
								this.$nextTick(() => {
									this.isRouterAlive = true
								})
								return
							}
							this.$message.success('重新提交成功！')
							this.visible = false
							this.$refs.table.refresh(true)
						})
					} else {
						console.log('error submit!!')
						return false
					}
				})
			},
			1000, {
			leading: true,
			trailing: false,
		}
		),
		removei(index) {
			console.log(index)
			this.info.bizGoodsInfos.splice(index, 1)
		},
		handleCancel() {
			this.visible = false
		},
		timeChange(date) {
			this.info.expectDate = date
		},
		add_detail() {
			this.info.bizGoodsInfos.push({
				expectDate: '',
				itemType: '',
				name: '', //物品名称
				model: '', //规格型号
				amount: '', //数量
				unit: '', //单位
				remark: '', //备注
				usages: undefined, //采购物品实际使用
			})
		},
		add_detail2() {
			this.reimburseform.reimburseDetails.push({
				expenseTime: '',
				types: undefined,
				money: '',
				remark: ''
			})
		},
		add_detail3() {
			this.paymentform.paymentDetails.push({
				invoice: '',
				thisPayment: '', //本次支付金额
				remark: '', //	费用明细
			})
		},
		getdata(data) {
			this.info.cc = data
		},
		getcardata(data) {
			this.carform.cc = data
		},
		getreturncardata(data) {
			this.returncarform.cc = data
		},
		scrapgetdata() {
			this.scrapform.cc = data
		},
		servicegetdata(data) {
			this.serviceform.cc = data
		},
		returngetdata(data) {
			this.returnform.cc = data
		},
		applygetdata(data) {
			this.form.cc = data
		},
		reimbursegetdata(data) {
			this.reimburseform.cc = data
		},
		paymentgetdata(data) {
			this.paymentform.cc = data
		},
		receivegetdata(data) {
			this.receiveform.cc = data
		},
		currencygetdata(data) {
			this.currencyform.cc = data
		},
		adjustmentgetdata(data) {
			this.adjustmentform.cc = data
		},
		salarygetdata(data) {
			this.salaryform.cc = data
		},
		sealgetdata(data) {
			this.sealform.cc = data
			// if(this.carbon == 1) {
			// 	this.sealform.cc == []
			// }
		},
		operationgetdata(data) {
			this.operationform.cc = data
		},
		handFlow(row) {
			var obj = {
				procInstId: row.procInstId,
				procDefKey: row.procDefKey
			}
			this.$refs.modalflow.show(obj)
		},
		// onSelectChange(selectedRowKeys, selectedRows) {
		// 	console.log(selectedRowKeys, selectedRowKeys, '===============================')
		// 	this.selectedRowKeys = selectedRowKeys
		// 	this.selectedRows = selectedRows
		// },
		handleAdd() {
			this.$refs.modal.add()
		},
		tenderEvent() {
			this.$refs.tenderApply.show()
		},
		needClick() {
				this.$refs.tender.show()
		},
		handelAuditone(record) {
			this.recordNumber = 1
			this.record = record
			var fdStart = record.procDefKey.indexOf("payment-")
			if (fdStart == 0) {
				this.$refs.newPaymentModel.init(record)
			}else {
				const modal = modalMap[record.procDefKey]
				console.log(record.procDefKey,'modal===============')
				this.$refs[modal].show({
					businessKey: record.id,
					procInstId: record.procInstId,
					procDefKey: record.procDefKey,
					recordNumber: 1,
					tableId: record.tableId,
					result: record.result
				})
				}
				// this.$refs.modalflow.show(obj)
			},
			againAudit(record) {
				// var fdStart =  record.procDefKey.indexOf("payment-")
				// if(fdStart == 0) {
				// 	this.$nextTick(() => {
				// 		this.$refs.reApply.show(record)
				// 	})
				// }else {
					this.moneY = ''
					this.isRouterAlive = false
					this.$nextTick(() => {
						this.isRouterAlive = true
					})
					this.companylist.forEach((item) => {
						if (item.dept_id == this.$store.getters.userInfo.companyId) {
							this.deptlist = item.child_lis
						}
					})
					listAllPage({
						pageNum: 1,
						pageSize: 999,
					}).then((res) => {
						this.plateNumberList = res.rows
					})
					this.plateNumberList2 = []
					this.adjustmentform = {}
					this.salaryform = {}
					this.carform = {}
					this.info = {
						cc: [], //抄送人
						expectDate: '',
						ascriptionDept: undefined,
						itemType: undefined,
						remark: '',
						bizGoodsInfos: [{
							expectDate: '',
							itemType: '',
							name: '', //物品名称
							model: '', //规格型号
							amount: '', //数量
							unit: '', //单位
							remark: '', //备注
							usages: undefined, //采购物品实际使用
						}]
					}
					this.form = {
						// cc: '', //	抄送人
						// ccIds: [],
						// ccDeptId: '', //抄送人部门id
						cc: [],
						applyCode: '', //审批编号
						contractCode: '', //	合同编号
						contractName: '', //	合同名称
						customerName: '', //	客户名称
						contractDate: '', //	合同日期
						projectName: '', //	项目名称
						projectCode: '', //项目编号
						expiryDate: '', //	到期日期
						contractAmount: '', //	合同金额;元）
						customerContact: '', //客户联系人
						contactInformation: '', //	联系方式
						follower: undefined, //	跟进人
						followerDept: '', //	跟进人部门
					}
					this.reimburseform = {
						cc: [],
						reimbursementCode: '',
						reimburseType: undefined,
						associateApply: [],
						reimburseMoneyTotal: '',
						remark: '',
						remarkSpec: '',
						name: '',
						accountNum: '',
						bank: '',
						reimburseDetails: [{
							expenseTime: '',
							types: undefined,
							money: '',
							remark: ''
						}],
					}
					this.paymentform = {
						cc: [],
						companyId: undefined,
						subjectionDeptId: undefined, //:'',//隶属公司部门
						associateApply: [], //:'',//	付款申请编号
						paymentType: undefined, //:'',//	关联审批单
						auditCode: '', //:'',//	审批单号
						provinceName: '',
						cityName: '',
						cc: '', //:'',//	抄送人
						ccDeptId: '',
						ccIds: [],
						invoice: '',
						projectType: undefined, //:'',//	款项类目
						projectName: '', //:'',//项目名称
						projectMoney: '', //:'',//	付款总金额
						projectCode: '', //:'',//项目编号
						paidCount: '', //:'',//	已付金额
						payCount: '', //	本次付款总金额
						accountType: '', //	账户类型
						name: '', //	支付对象(户名)
						accountNum: '', //	支付对象(账号)
						bank: '', //	支付对象(开户行)
						province: '', //	支行地址（省）
						city: '', //	支行地址（市）
						branchBank: '', //	银行支行
						remarkSpec: '', //	特殊备注
						remark: '', //	备注
						paymentDetails: [{
							invoice: '',
							thisPayment: '', //本次支付金额
							remark: '', //	费用明细
						}, ],
					}
					this.operationform = {
						cc: [],
						applyCode: '',
						companyId: undefined,
						applyDeptId: undefined,
						applyUser: undefined,
						projectCode: '',
						projectName: '',
						projectPrice: '',
						paymentObject: '',
						remark: '',
					}
					this.receiveform = {
						cc: [],
						reason: '',
						remark: '',
						old_goods: [],
						goods: [],
					}
					this.returnform = {
						cc: [],
						returnReason: '',
						old_goods: [],
						applyCode: '',
						purchaseCode: '',
					}
					this.sealform = {
						cc: [],
						applyCode: '',
						userDept: undefined,
						sealUser: undefined,
						stampDate: '',
						document: '',
						documentNum: '',
						documentType: undefined,
						sealType: undefined,
						remark: '',
					}
					this.currencyform = {
						cc: [],
						applyCode: '',
						content: '',
						detail: '',
					}
					this.serviceform = {
						cc: [],
						reviewCode: '',
						deptId: undefined,
						companyId: undefined,
						types: undefined,
						paymentDetails: '',
						paymentMode: undefined,
						paymentDate: '',
						paymentObject: '',
						bankOfDeposit: '',
						bankAccount: '',
						amountTotal: '',
						remark: '',
						bizReviewInfos: [{}]
					}
					const modal = modalMap[record.procDefKey]
					// if (modal == 'purchasemodal') {
					// 	this.ccC = 'purchase'
					// 	getPurchaseByBusiness(record.id).then((res) => {
					// 		if (res.code === 200) {
					// 			this.info = res.data
					// 			this.info.bizGoodsInfos.forEach(item => {
					// 				item.usages = Number(item.usages)
					// 			})
					// 			this.visible = true
					// 		}
					// 	})
					// } else
					if (modal == 'contractmodal') {
						this.ccC = 'contract_ys'
						contract_apply_get(record.id).then((res) => {
							if (res.code === 200) {
								this.form = res.data
								this.form.cc = []
								this.uploadData.type = 'contract-file'
								this.uploadDataImg.type = 'contract-img'
								contract_apply_code().then((res) => {
									this.uploadData.code = res.data
									this.uploadDataImg.code = res.data
									this.form.applyCode = res.data
								})
							}
							this.is_show_apply = true
						})
					} else if (modal == "reimbursementmodal") {
						this.ccC = 'reimburse'
						getReimburseApply(record.id).then(res => {
							if (res.code == 200) {
								this.auditCodeData = []
								this.auditCodeData2 = []
								this.auditCodeData3 = []
								this.auditCodeData4 = []
								this.reimburseform = res.data
								this.reimburseform.cc = []
								this.uploadData.type = 'reimburse-appendix'
								this.uploadDataImg.type = 'reimburse-certificate'
								apply_code().then(res => {
									this.reimburseform.reimbursementCode = res.data
									this.uploadData.code = res.data
									this.uploadDataImg.code = res.data
								})
							}
							this.reimburse_visible = true
						})
					} else if (modal == "paymentmodal") {
						this.ccC = 'payment'
						payment_apply_get(record.id).then(res => {
							if (res.code == 200) {
								this.auditCodeData = []
								this.auditCodeData2 = []
								this.auditCodeData3 = []
								this.auditCodeData4 = []
								this.paymentform = res.data
								console.log(this.paymentform, 'this.paymentform=======================')

								this.paymentform.accountType = ''
								this.paymentform.name = ''
								this.paymentform.accountNum = ''
								this.paymentform.bank = ''
								this.paymentform.province = ''
								this.paymentform.city = ''
								this.paymentform.provinceName = ''
								this.paymentform.cityName = ''
								this.paymentform.branchBank = ''

								this.paymentform.subjectionDeptId = res.data.deptId
								this.paymentform.cc = []
								this.uploadData.type = 'payment-appendix'
								this.uploadDataImg.type = 'payment-certificate'
								payment_apply_code().then(res => {
									this.paymentform.paymentCode = res.data
									this.uploadData.code = res.data
									this.uploadDataImg.code = res.data
								})
							}
							this.payment_visible = true
								tree_all().then((res) => {
							if(res.code == 200) {
							this.companylist2 = res.data[0]
							this.companylist2.forEach((item) => {
							item.children.forEach(item2 => {
								if (item2.deptId == this.paymentform.subjectionDeptId) {
								this.deptlist2= item.children
								this.paymentform.companyId = item.deptId
								this.paymentform.companyName = item.title
							console.log(this.deptlist, 'deptlist===================')
						}

							})
						
					})  
					console.log(this.paymentform, 'this.paymentform===============')
						console.log(this.companylist2, 'this.companylist2============================')
						console.log(this.paymentform.companyId, 'this.paymentform.companyId================')

					} else {
						this.$message.error(res.msg)
					}
				})
							// get_dept_tree2().then((res) => {
							// 	res.data.dept_lis.forEach(ite => {
							// 		ite.child_lis.forEach(item => {
							// 			if (item.dept_id == this.paymentform
							// 				.subjectionDeptId) {
							// 				this.deptlist2 = ite.child_lis
							// 				this.paymentform.companyId = ite.dept_id
							// 			}
							// 		})
							// 	})
							// })
						})
					} else if (modal == 'operationmodal') {
						this.ccC = 'businessMoney'
						getBusinessFeeApply(record.id).then(res => {
							if (res.code == 200) {
								console.log(res.data, 'res.data=====================')
								res.data.ifOld = String(res.data.ifOld)
								this.operationform = res.data
								this.uploadData.type = 'business-fee'
								list_code().then(res => {
									this.operationform.applyCode = res.data
									this.uploadData.code = res.data
								})
							}
							this.operation_visible = true
							get_dept_tree2().then((res) => {
								res.data.dept_lis.forEach(ite => {
									ite.child_lis.forEach(item => {
										if (item.dept_id == this.operationform.applyDeptId) {
											this.deptlist2 = ite.child_lis
											this.operationform.companyId = ite.dept_id
											this.leaderid(this.operationform.applyDeptId)
										}
									})
								})
							})
						})
					} else if (modal == 'receiveModal') {
						this.ccC = 'claim'
						getClaimByBusiness(record.id).then(res => {
							if (res.code == 200) {
								this.receiveform = res.data
							}
							this.is_apply_show = true
						})
					} else if (modal == "returnmodal") {
						this.ccC = 'goodsRejected'
						goods_rejected_info(record.id).then(res => {
							if (res.code == 200) {
								this.returnform = res.data
								this.returnform.cc = []
								this.uploadData.type = 'goods-rejected-file'
								this.uploadDataImg.type = 'goods-rejected-img'
								goods_rejected_code().then(res => {
									this.returnform.applyCode = res.data
									this.uploadData.code = res.data
									this.uploadDataImg.code = res.data
								})
							}
							this.return_visible = true
						})
					} else if (modal == "sealmodal") {
						this.ccC = 'seal'
						seal_apply_get(record.id).then(res => {
							if (res.code == 200) {
								this.sealform = res.data
								console.log(res.data, 'res.data==================')
								this.returnform.cc = []
								this.leaderid(this.sealform.userDept)
								this.uploadData.type = 'seal-appendix'
								this.uploadDataImg.type = 'seal-certificate'
								seal_apply_code().then(res => {
									this.sealform.applyCode = res.data
									this.uploadData.code = res.data
									this.uploadDataImg.code = res.data
								})
							}
							this.sealvisit = true
						})
					} else if (modal == "currencymodal") {
						this.ccC = 'universal'
						universal_apply_get(record.id).then(res => {
							if (res.code == 200) {
								this.currencyform = res.data
								this.returnform.cc = []
								this.uploadData.type = 'universal-appendix'
								this.uploadDataImg.type = 'universal-certificate'
								universal_apply_code().then(res => {
									this.currencyform.applyCode = res.data
									this.uploadData.code = res.data
									this.uploadDataImg.code = res.data
								})
							}
							this.currencyvisit = true
						})
					} else if (modal == "servicemodal") {
						this.ccC = 'review'
						getReviewApply(record.id).then(res => {
							if (res.code == 200) {
								this.serviceform = res.data
								this.companylist2.forEach((item) => {
							if (item.deptId == this.serviceform.companyId) {
							this.deptlist = item.children
							console.log(this.deptlist, 'deptlist===================')
							}
							})

								this.uploadDataImg.type = 'review'
								review_apply_code().then(res => {
									this.serviceform.reviewCode = res.data
									this.uploadDataImg.code = res.data
								})
							}
							this.service_visit = true
						})

					} else if (modal == "scrapmodal") {
						this.ccC = 'scrapped'
						getScrapByBusiness(record.id).then(res => {
							if (res.code == 200) {
								this.scrapform = res.data
								this.scrapform.cc = []
								this.selectedRowKeys2.push(res.data.assertId)
							}
							this.scrap_visit = true
							this.hasSelectedAssert = false
							this.get_lis2()

						})
					} else if (modal == "salarymodal") {
						this.ccC = 'xz_approval'
						salary_approval_get(record.id).then(res => {
							if (res.code == 200) {
								this.salaryform = res.data
								this.leaderid(this.salaryform.userDept)
								this.salaryform.cc = []
								salary_approval_code().then(res => {
									this.salaryform.applyCode = res.data
									this.uploadData.code = res.data
									this.uploadDataImg.code = res.data
								})
								this.uploadData.type = 'xzhz-appendix'
								this.uploadDataImg.type = 'xzhz-certificate'
							}
							this.salaryvisit = true
						})
					} else if (modal == "adjustmentmodal") {
						this.ccC = 'xz_adjustment'
						salary_adjustment_get(record.id).then(res => {
							if (res.code == 200) {
								this.adjustmentform = res.data
								this.leaderid(this.adjustmentform.userDept)
								this.adjustmentform.cc = []
								salary_adjustment_code().then(res => {
									this.adjustmentform.applyCode = res.data
									this.uploadData.code = res.data
									this.uploadDataImg.code = res.data
								})
								this.uploadData.type = 'xztz-appendix'
							}
							this.adjustmentvisit = true
						})
					} else if (modal == "carmodal") {
						this.ccC = 'carApply'
						getCarApply(record.id).then(res => {
							if (res.code == 200) {
								this.carform = res.data
								this.carform.isDriver = Number(this.carform.isDriver)
								this.carform.cc = []
								this.carform.goToDate = ''
								this.carform.goBackDate = ''
								this.carform.plateNumber = ''
								biz_car_apply_code().then(res => {
									this.carform.applyCode = res.data
								})
							}
							this.carvisible = true
						})
					} else if (modal == "returncarmodal") {
						this.auditCodeData = []
						this.auditCodeData2 = []
						this.auditCodeData3 = []
						this.auditCodeData4 = []
						this.returncarform['oils'] = [{
							fuelMileage: '',
							fuelMoney: '',
							key: Date.now(),
						}, ]
						this.ccC = 'carSubsidyApply'
						returnCarApply(record.id).then(res => {
							if (res.code == 200) {
								var row = res.data.useCarDate.split(' ')
								Object.assign(res.data, {
									data: row[0],
									time: row[1]
								})

								this.returncarform = res.data
								console.log(this.returncarform , 'this.returncarform ===================')
								this.returncarform.vehicleCondition = this.returncarform.vehicleCondition + ''
								this.returncarform.carTypes = this.returncarform.carTypes + ''
								this.returncarform.cc = []
								biz_car_subsidy_apply_code().then(res => {
									this.returncarform.applyCode = res.data
								})
							}
							this.returncarvisible = true
						})
					} else if (modal == "chargemodal") {
						getCoverApply(record.id).then(res => {
							if (res.code == 200) {
								this.$refs.servicefeeapplication.show(res.data)
							}
						})
					} else if (modal == "othermodal") {
						getOtherApply(record.id).then(res => {
							if (res.code == 200) {
								this.$refs.otherapplication.show(res.data)
							}
						})
					} else if (modal == "feedbackmodal") {
						feedback_get(record.id).then(res => {
							if (res.code == 200) {
								this.$refs.feedbackapplication.show(res.data)
							}
						})
					}
					// else if (modal == "inventorymodal") {
					// 	consumables_get(record.id).then(res => {
					// 		if (res.code == 200) {
					// 			if(res.data.types==1){
					// 				this.$refs.consumablesapplication.showprofit(res.data)
					// 			}else if(res.data.types==2){
					// 				this.$refs.consumablesapplication.showloss(res.data)
					// 			}

					// 		}
					// 	})
					// } 
					else {
						this.$message.success('功能开发中！')
					}
				// }
			},
			handleOk() {
				this.$refs.table.refresh(true)
				this.addApplyvisit = false
			},
			// 撤销
			cancel(ids) {
				// const idstr = ids.map(r => { return '\'' + r + '\'' }).join('')
				var _this = this
				this.$confirm({
					title: '是否确认撤销?',
					onOk() {
						delProcessIns({
							ids: ids.join(','),
							reason: '主动撤销',
						}).then((res) => {
							if (res.code === 200) {
								_this.$message.success('撤销成功')
								_this.handleOk()
			                }
						})
					}
				})
			// this.$refs.modalflow.show(obj)
		},
// 		againAudit(record) {
// 			var fdStart = record.procDefKey.indexOf("payment-")
// 			if (fdStart == 0) {
// 				this.$nextTick(() => {
// 					this.$refs.reApply.show(record)
// 				})
// 			} else {
// 				this.moneY = ''
// 				this.isRouterAlive = false
// 				this.$nextTick(() => {
// 					this.isRouterAlive = true
// 				})
// 				this.companylist.forEach((item) => {
// 					if (item.dept_id == this.$store.getters.userInfo.companyId) {
// 						this.deptlist = item.child_lis
// 					}
// 				})
// 				listAllPage({
// 					pageNum: 1,
// 					pageSize: 999,
// 				}).then((res) => {
// 					this.plateNumberList = res.rows
// 				})
// 				this.plateNumberList2 = []
// 				this.adjustmentform = {}
// 				this.salaryform = {}
// 				this.carform = {}
// 				this.info = {
// 					cc: [], //抄送人
// 					expectDate: '',
// 					ascriptionDept: undefined,
// 					itemType: undefined,
// 					remark: '',
// 					bizGoodsInfos: [{
// 						expectDate: '',
// 						itemType: '',
// 						name: '', //物品名称
// 						model: '', //规格型号
// 						amount: '', //数量
// 						unit: '', //单位
// 						remark: '', //备注
// 						usages: undefined, //采购物品实际使用
// 					}]
// 				}
// 				this.form = {
// 					// cc: '', //	抄送人
// 					// ccIds: [],
// 					// ccDeptId: '', //抄送人部门id
// 					cc: [],
// 					applyCode: '', //审批编号
// 					contractCode: '', //	合同编号
// 					contractName: '', //	合同名称
// 					customerName: '', //	客户名称
// 					contractDate: '', //	合同日期
// 					projectName: '', //	项目名称
// 					projectCode: '', //项目编号
// 					expiryDate: '', //	到期日期
// 					contractAmount: '', //	合同金额;元）
// 					customerContact: '', //客户联系人
// 					contactInformation: '', //	联系方式
// 					follower: undefined, //	跟进人
// 					followerDept: '', //	跟进人部门
// 				}
// 				this.reimburseform = {
// 					cc: [],
// 					reimbursementCode: '',
// 					reimburseType: undefined,
// 					associateApply: [],
// 					reimburseMoneyTotal: '',
// 					remark: '',
// 					remarkSpec: '',
// 					name: '',
// 					accountNum: '',
// 					bank: '',
// 					reimburseDetails: [{
// 						expenseTime: '',
// 						types: undefined,
// 						money: '',
// 						remark: ''
// 					}],
// 				}
// 				this.paymentform = {
// 					cc: [],
// 					companyId: undefined,
// 					subjectionDeptId: undefined, //:'',//隶属公司部门
// 					associateApply: [], //:'',//	付款申请编号
// 					paymentType: undefined, //:'',//	关联审批单
// 					auditCode: '', //:'',//	审批单号
// 					provinceName: '',
// 					cityName: '',
// 					cc: '', //:'',//	抄送人
// 					ccDeptId: '',
// 					ccIds: [],
// 					invoice: '',
// 					projectType: undefined, //:'',//	款项类目
// 					projectName: '', //:'',//项目名称
// 					projectMoney: '', //:'',//	付款总金额
// 					projectCode: '', //:'',//项目编号
// 					paidCount: '', //:'',//	已付金额
// 					payCount: '', //	本次付款总金额
// 					accountType: '', //	账户类型
// 					name: '', //	支付对象(户名)
// 					accountNum: '', //	支付对象(账号)
// 					bank: '', //	支付对象(开户行)
// 					province: '', //	支行地址（省）
// 					city: '', //	支行地址（市）
// 					branchBank: '', //	银行支行
// 					remarkSpec: '', //	特殊备注
// 					remark: '', //	备注
// 					paymentDetails: [{
// 						invoice: '',
// 						thisPayment: '', //本次支付金额
// 						remark: '', //	费用明细
// 					},],
// 				}
// 				this.operationform = {
// 					cc: [],
// 					applyCode: '',
// 					companyId: undefined,
// 					applyDeptId: undefined,
// 					applyUser: undefined,
// 					projectCode: '',
// 					projectName: '',
// 					projectPrice: '',
// 					paymentObject: '',
// 					remark: '',
// 				}
// 				this.receiveform = {
// 					cc: [],
// 					reason: '',
// 					remark: '',
// 					old_goods: [],
// 					goods: [],
// 				}
// 				this.returnform = {
// 					cc: [],
// 					returnReason: '',
// 					old_goods: [],
// 					applyCode: '',
// 					purchaseCode: '',
// 				}
// 				this.sealform = {
// 					cc: [],
// 					applyCode: '',
// 					userDept: undefined,
// 					sealUser: undefined,
// 					stampDate: '',
// 					document: '',
// 					documentNum: '',
// 					documentType: undefined,
// 					sealType: undefined,
// 					remark: '',
// 				}
// 				this.currencyform = {
// 					cc: [],
// 					applyCode: '',
// 					content: '',
// 					detail: '',
// 				}
// 				this.serviceform = {
// 					cc: [],
// 					reviewCode: '',
// 					deptId: undefined,
// 					companyId: undefined,
// 					types: undefined,
// 					paymentDetails: '',
// 					paymentMode: undefined,
// 					paymentDate: '',
// 					paymentObject: '',
// 					bankOfDeposit: '',
// 					bankAccount: '',
// 					amountTotal: '',
// 					remark: '',
// 					bizReviewInfos: [{}]
// 				}
// 				const modal = modalMap[record.procDefKey]
// 				// if (modal == 'purchasemodal') {
// 				// 	this.ccC = 'purchase'
// 				// 	getPurchaseByBusiness(record.id).then((res) => {
// 				// 		if (res.code === 200) {
// 				// 			this.info = res.data
// 				// 			this.info.bizGoodsInfos.forEach(item => {
// 				// 				item.usages = Number(item.usages)
// 				// 			})
// 				// 			this.visible = true
// 				// 		}
// 				// 	})
// 				// } else
// 				if (modal == 'contractmodal') {
// 					this.ccC = 'contract_ys'
// 					contract_apply_get(record.id).then((res) => {
// 						if (res.code === 200) {
// 							this.form = res.data
// 							this.form.cc = []
// 							this.uploadData.type = 'contract-file'
// 							this.uploadDataImg.type = 'contract-img'
// 							contract_apply_code().then((res) => {
// 								this.uploadData.code = res.data
// 								this.uploadDataImg.code = res.data
// 								this.form.applyCode = res.data
// 							})
// 						}
// 						this.is_show_apply = true
// 					})
// 				} else if (modal == "reimbursementmodal") {
// 					this.ccC = 'reimburse'
// 					getReimburseApply(record.id).then(res => {
// 						if (res.code == 200) {
// 							this.auditCodeData = []
// 							this.auditCodeData2 = []
// 							this.auditCodeData3 = []
// 							this.auditCodeData4 = []
// 							this.reimburseform = res.data
// 							this.reimburseform.cc = []
// 							this.uploadData.type = 'reimburse-appendix'
// 							this.uploadDataImg.type = 'reimburse-certificate'
// 							apply_code().then(res => {
// 								this.reimburseform.reimbursementCode = res.data
// 								this.uploadData.code = res.data
// 								this.uploadDataImg.code = res.data
// 							})
// 						}
// 						this.reimburse_visible = true
// 					})
// 				} else if (modal == "paymentmodal") {
// 					this.ccC = 'payment'
// 					payment_apply_get(record.id).then(res => {
// 						if (res.code == 200) {
// 							this.auditCodeData = []
// 							this.auditCodeData2 = []
// 							this.auditCodeData3 = []
// 							this.auditCodeData4 = []
// 							this.paymentform = res.data
// 							console.log(this.paymentform, 'this.paymentform=======================')

// 							this.paymentform.accountType = ''
// 							this.paymentform.name = ''
// 							this.paymentform.accountNum = ''
// 							this.paymentform.bank = ''
// 							this.paymentform.province = ''
// 							this.paymentform.city = ''
// 							this.paymentform.provinceName = ''
// 							this.paymentform.cityName = ''
// 							this.paymentform.branchBank = ''

// 							this.paymentform.subjectionDeptId = res.data.deptId
// 							this.paymentform.cc = []
// 							this.uploadData.type = 'payment-appendix'
// 							this.uploadDataImg.type = 'payment-certificate'
// 							payment_apply_code().then(res => {
// 								this.paymentform.paymentCode = res.data
// 								this.uploadData.code = res.data
// 								this.uploadDataImg.code = res.data
// 							})
// 						}
// 						this.payment_visible = true
// 						tree_all().then((res) => {
// 							if (res.code == 200) {
// 								this.companylist2 = res.data[0]
// 								this.companylist2.forEach((item) => {
// 									item.children.forEach(item2 => {
// 										if (item2.deptId == this.paymentform.subjectionDeptId) {
// 											this.deptlist2 = item.children
// 											this.paymentform.companyId = item.deptId
// 											this.paymentform.companyName = item.title
// 											console.log(this.deptlist, 'deptlist===================')
// 										}

// 									})

// 								})
// 								console.log(this.paymentform, 'this.paymentform===============')
// 								console.log(this.companylist2, 'this.companylist2============================')
// 								console.log(this.paymentform.companyId, 'this.paymentform.companyId================')

// >>>>>>> 54085d7a23bbc983f03dd73f14540df7d5ade9ee
// 							} else {
// 								this.$message.error(res.msg)
// 							}
// 						})
// 						// get_dept_tree2().then((res) => {
// 						// 	res.data.dept_lis.forEach(ite => {
// 						// 		ite.child_lis.forEach(item => {
// 						// 			if (item.dept_id == this.paymentform
// 						// 				.subjectionDeptId) {
// 						// 				this.deptlist2 = ite.child_lis
// 						// 				this.paymentform.companyId = ite.dept_id
// 						// 			}
// 						// 		})
// 						// 	})
// 						// })
// 					})
// 				} else if (modal == 'operationmodal') {
// 					this.ccC = 'businessMoney'
// 					getBusinessFeeApply(record.id).then(res => {
// 						if (res.code == 200) {
// 							console.log(res.data, 'res.data=====================')
// 							this.operationform = res.data
// 							this.uploadData.type = 'business-fee'
// 							list_code().then(res => {
// 								this.operationform.applyCode = res.data
// 								this.uploadData.code = res.data
// 							})
// 						}
// 						this.operation_visible = true
// 						get_dept_tree2().then((res) => {
// 							res.data.dept_lis.forEach(ite => {
// 								ite.child_lis.forEach(item => {
// 									if (item.dept_id == this.operationform.applyDeptId) {
// 										this.deptlist2 = ite.child_lis
// 										this.operationform.companyId = ite.dept_id
// 										this.leaderid(this.operationform.applyDeptId)
// 									}
// 								})
// 							})
// 						})
// 					})
// 				} else if (modal == 'receiveModal') {
// 					this.ccC = 'claim'
// 					getClaimByBusiness(record.id).then(res => {
// 						if (res.code == 200) {
// 							this.receiveform = res.data
// 						}
// 						this.is_apply_show = true
// 					})
// 				} else if (modal == "returnmodal") {
// 					this.ccC = 'goodsRejected'
// 					goods_rejected_info(record.id).then(res => {
// 						if (res.code == 200) {
// 							this.returnform = res.data
// 							this.returnform.cc = []
// 							this.uploadData.type = 'goods-rejected-file'
// 							this.uploadDataImg.type = 'goods-rejected-img'
// 							goods_rejected_code().then(res => {
// 								this.returnform.applyCode = res.data
// 								this.uploadData.code = res.data
// 								this.uploadDataImg.code = res.data
// 							})
// 						}
// 						this.return_visible = true
// 					})
// 				} else if (modal == "sealmodal") {
// 					this.ccC = 'seal'
// 					seal_apply_get(record.id).then(res => {
// 						if (res.code == 200) {
// 							this.sealform = res.data
// 							console.log(res.data, 'res.data==================')
// 							this.returnform.cc = []
// 							this.leaderid(this.sealform.userDept)
// 							this.uploadData.type = 'seal-appendix'
// 							this.uploadDataImg.type = 'seal-certificate'
// 							seal_apply_code().then(res => {
// 								this.sealform.applyCode = res.data
// 								this.uploadData.code = res.data
// 								this.uploadDataImg.code = res.data
// 							})
// 						}
// 						this.sealvisit = true
// 					})
// 				} else if (modal == "currencymodal") {
// 					this.ccC = 'universal'
// 					universal_apply_get(record.id).then(res => {
// 						if (res.code == 200) {
// 							this.currencyform = res.data
// 							this.returnform.cc = []
// 							this.uploadData.type = 'universal-appendix'
// 							this.uploadDataImg.type = 'universal-certificate'
// 							universal_apply_code().then(res => {
// 								this.currencyform.applyCode = res.data
// 								this.uploadData.code = res.data
// 								this.uploadDataImg.code = res.data
// 							})
// 						}
// 						this.currencyvisit = true
// 					})
// 				} else if (modal == "servicemodal") {
// 					this.ccC = 'review'
// 					getReviewApply(record.id).then(res => {
// 						if (res.code == 200) {
// 							this.serviceform = res.data
// 							this.companylist2.forEach((item) => {
// 								if (item.deptId == this.serviceform.companyId) {
// 									this.deptlist = item.children
// 									console.log(this.deptlist, 'deptlist===================')
// 								}
// 							})

// 							this.uploadDataImg.type = 'review'
// 							review_apply_code().then(res => {
// 								this.serviceform.reviewCode = res.data
// 								this.uploadDataImg.code = res.data
// 							})
// 						}
// 						this.service_visit = true
// 					})

// 				} else if (modal == "scrapmodal") {
// 					this.ccC = 'scrapped'
// 					getScrapByBusiness(record.id).then(res => {
// 						if (res.code == 200) {
// 							this.scrapform = res.data
// 							this.scrapform.cc = []
// 							this.selectedRowKeys2.push(res.data.assertId)
// 						}
// 						this.scrap_visit = true
// 						this.hasSelectedAssert = false
// 						this.get_lis2()

// 					})
// 				} else if (modal == "salarymodal") {
// 					this.ccC = 'xz_approval'
// 					salary_approval_get(record.id).then(res => {
// 						if (res.code == 200) {
// 							this.salaryform = res.data
// 							this.leaderid(this.salaryform.userDept)
// 							this.salaryform.cc = []
// 							salary_approval_code().then(res => {
// 								this.salaryform.applyCode = res.data
// 								this.uploadData.code = res.data
// 								this.uploadDataImg.code = res.data
// 							})
// 							this.uploadData.type = 'xzhz-appendix'
// 							this.uploadDataImg.type = 'xzhz-certificate'
// 						}
// 						this.salaryvisit = true
// 					})
// 				} else if (modal == "adjustmentmodal") {
// 					this.ccC = 'xz_adjustment'
// 					salary_adjustment_get(record.id).then(res => {
// 						if (res.code == 200) {
// 							this.adjustmentform = res.data
// 							this.leaderid(this.adjustmentform.userDept)
// 							this.adjustmentform.cc = []
// 							salary_adjustment_code().then(res => {
// 								this.adjustmentform.applyCode = res.data
// 								this.uploadData.code = res.data
// 								this.uploadDataImg.code = res.data
// 							})
// 							this.uploadData.type = 'xztz-appendix'
// 						}
// 						this.adjustmentvisit = true
// 					})
// 				} else if (modal == "carmodal") {
// 					this.ccC = 'carApply'
// 					getCarApply(record.id).then(res => {
// 						if (res.code == 200) {
// 							this.carform = res.data
// 							this.carform.isDriver = Number(this.carform.isDriver)
// 							this.carform.cc = []
// 							this.carform.goToDate = ''
// 							this.carform.goBackDate = ''
// 							this.carform.plateNumber = ''
// 							biz_car_apply_code().then(res => {
// 								this.carform.applyCode = res.data
// 							})
// 						}
// 						this.carvisible = true
// 					})
// 				} else if (modal == "returncarmodal") {
// 					this.auditCodeData = []
// 					this.auditCodeData2 = []
// 					this.auditCodeData3 = []
// 					this.auditCodeData4 = []
// 					this.returncarform['oils'] = [{
// 						fuelMileage: '',
// 						fuelMoney: '',
// 						key: Date.now(),
// 					},]
// 					this.ccC = 'carSubsidyApply'
// 					returnCarApply(record.id).then(res => {
// 						if (res.code == 200) {
// 							var row = res.data.useCarDate.split(' ')
// 							Object.assign(res.data, {
// 								data: row[0],
// 								time: row[1]
// 							})

// 							this.returncarform = res.data
// 							console.log(this.returncarform, 'this.returncarform ===================')
// 							this.returncarform.vehicleCondition = this.returncarform.vehicleCondition + ''
// 							this.returncarform.carTypes = this.returncarform.carTypes + ''
// 							this.returncarform.cc = []
// 							biz_car_subsidy_apply_code().then(res => {
// 								this.returncarform.applyCode = res.data
// 							})
// 						}
// 						this.returncarvisible = true
// 					})
// 				} else if (modal == "chargemodal") {
// 					getCoverApply(record.id).then(res => {
// 						if (res.code == 200) {
// 							this.$refs.servicefeeapplication.show(res.data)
// 						}
// 					})
// 				} else if (modal == "othermodal") {
// 					getOtherApply(record.id).then(res => {
// 						if (res.code == 200) {
// 							this.$refs.otherapplication.show(res.data)
// 						}
// 					})
// 				} else if (modal == "feedbackmodal") {
// 					feedback_get(record.id).then(res => {
// 						if (res.code == 200) {
// 							this.$refs.feedbackapplication.show(res.data)
// 						}
// 					})
// 				}
// 				// else if (modal == "inventorymodal") {
// 				// 	consumables_get(record.id).then(res => {
// 				// 		if (res.code == 200) {
// 				// 			if(res.data.types==1){
// 				// 				this.$refs.consumablesapplication.showprofit(res.data)
// 				// 			}else if(res.data.types==2){
// 				// 				this.$refs.consumablesapplication.showloss(res.data)
// 				// 			}

// 				// 		}
// 				// 	})
// 				// } 
// 				else {
// 					this.$message.success('功能开发中！')
// 				}
// 			}
// 		},
		// handleOk() {
		// 	this.$refs.table.refresh(true)
		// 	this.addApplyvisit = false
		// },
		// 撤销
		// cancel(ids) {
		// 	// const idstr = ids.map(r => { return '\'' + r + '\'' }).join('')
		// 	var _this = this
		// 	this.$confirm({
		// 		title: '是否确认撤销?',
		// 		onOk() {
		// 			delProcessIns({
		// 				ids: ids.join(','),
		// 				reason: '主动撤销',
		// 			}).then((res) => {
		// 				if (res.code === 200) {
		// 					_this.$message.success('撤销成功')
		// 					_this.handleOk()
		// 				} else {
		// 					_this.$message.error(res.msg)
		// 				}
		// 				_this.selectedRowKeys = []
		// 			})
		// 		},
		// 		onCancel() {
		// 			_this.$message.error('你点击了取消')
		// 		},
		// 		class: 'test',
		// 	})
		// },
		delByIds(ids) {
			console.log(ids)
			// const idstr = ids.map(r => { return '\'' + r + '\'' }).join('')
			var _this = this
			this.$confirm({
				title: '是否确认删除?',
				onOk() {
					delBusiness({
						ids: ids.join(','),
					}).then((res) => {
						if (res.code === 200) {
							_this.$message.success('删除成功')
							_this.handleOk()
						} else {
							_this.$message.error(res.msg)
						}
						_this.selectedRowKeys = []
					})
				},
				onCancel() {
					_this.$message.error('你点击了取消')
				},
				class: 'test',
			});
		},
	},
	watch: {
		/*
		  'selectedRows': function (selectedRows) {
			this.needTotalList = this.needTotalList.map(item => {
			  return {
				...item,
				total: selectedRows.reduce( (sum, val) => {
				  return sum + val[item.dataIndex]
				}, 0)
			  }
			})
		  }
		  */
	},
}
</script>
<style scoped>
.pay_top {
	width: 100%;
	float: left;
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.pay_top .form_title {
	margin-left: 15px;
	margin-bottom: 15px;
	font-size: 17px;
	color: #999;
}

.pay_top .close_icon {
	font-size: 20px;
	color: red;
	cursor: pointer;
}

.note {
	color: #f5222d !important;
}

.auditItem {
	border-radius: 5px;
	background-color: rgb(243, 245, 244);
	margin-left: 10px;
}

.close_icon2 {
	font-size: 14px;
	color: red;
	cursor: pointer;
}

.form_title {
	margin-left: 15px;
	margin-bottom: 15px;
	font-size: 17px;
	color: #999;
}

.form_title2 {
	margin-bottom: 15px;
	font-size: 17px;
	color: #999;
}

.btn_last {
	width: 100%;
	float: left;
	display: flex;
	justify-content: flex-end;
	align-items: flex-start;
}

.setback {
	height: 200px;
}

.setback .item {
	float: left;
	width: 120px;
	height: 80px;
	margin: 10px;
	padding: 10px;
	box-shadow: 0px 2px 6px lightgray;
	text-align: center;
	cursor: pointer;
}

.setback .item .size {
	font-weight: 700;
}

.last_title {
	margin-top: 20px;
	width: 100%;
	padding: 20px;
	background-color: #f8f8f7;
	color: #b6b6b6;
}

.rowBox {
	width: 100%;
	float: left;
	padding-left: 160px;
	box-sizing: border-box;
	margin-bottom: 20px;
}

.delico {
	cursor: pointer;
	font-size: 22px;
	color: red;
}

.closeIoc {
	height: 35px;
	width: 70px;
	display: flex;
	justify-content: center;
	align-items: center;
}
.content_main_center{
	height:calc(100% - 50px) !important
}
</style>
